var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _path2, _path3, _path4, _path5, _g18, _g19, _g20, _g21, _g22, _path6, _path7, _path8, _path9, _path10, _path11, _g23, _path12, _g24, _g25, _g26, _g27, _g28, _path13, _path14, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _path15, _g44, _g45, _g46, _g47, _path16, _path17, _g48, _path18, _g49, _g50, _path19, _path20, _g51, _g52, _rect, _rect2, _g53, _g54, _g55, _g56, _path21, _g57, _g58, _g59, _path22, _path23, _path24, _path25, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _path26, _path27, _path28, _path29, _g123, _path30, _path31, _path32, _path33, _g124, _g125, _g126, _g127, _g128, _path34, _path35, _path36, _path37, _g129, _path38, _path39, _path40, _path41, _g130, _g131, _g132, _line, _g133, _path42, _path43, _path44, _g134;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M1197.91,2247.167c10.2,3.517,21.117,9.736,27.95,17.277,0,0,15.269-1.863,35.66-12.667l10.035,23.625c-21.7,8.84-31.7,16.814-31.78,16.882a20.913,20.913,0,0,1-1.309,3.527c-3.729,7.953-29.781,7.649-44.237-7.534-12.33-12.937-22.867-34-21.941-38.759C1173.614,2242.634,1185.083,2242.749,1197.91,2247.167Z",
    transform: "translate(-1172.231 -2244.062)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    "data-name": "Caminho 157",
    d: "M1468.232,2260.752c-9.988,4.076-20.547,10.889-26.953,18.795,0,0-15.348-1.016-36.3-10.677l-8.714,24.143c22.159,7.627,32.576,15.037,32.664,15.1a20.873,20.873,0,0,0,1.5,3.448c4.162,7.735,30.159,5.993,43.754-9.967,11.6-13.6,20.953-35.216,19.766-39.912C1492.24,2254.885,1480.794,2255.633,1468.232,2260.752Z",
    transform: "translate(-1396.26 -2256.749)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    "data-name": "Caminho 171",
    d: "M1559.5,2060.15c-32.187-9.356-113.918,56.138-121.629,62.4a4.1,4.1,0,0,0-4.184-.247l-6.534,3.383a4.1,4.1,0,0,0-1.755,5.523L1449.111,2177a4.1,4.1,0,0,0,5.523,1.755l6.534-3.383a4.1,4.1,0,0,0,1.927-5.147c8.79-2.622,109.906-33.15,116.923-51.694C1587.354,2099.143,1593.3,2069.974,1559.5,2060.15Z",
    transform: "translate(-1424.942 -2059.237)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    "data-name": "Caminho 173",
    d: "M1065.241,2094.478c32.186-9.356,113.918,56.138,121.629,62.4a4.1,4.1,0,0,1,4.184-.247l6.534,3.383a4.1,4.1,0,0,1,1.755,5.523l-23.709,45.792a4.1,4.1,0,0,1-5.524,1.755l-6.534-3.383a4.1,4.1,0,0,1-1.926-5.147c-8.79-2.622-109.907-33.15-116.923-51.694C1037.391,2133.471,1031.445,2104.3,1065.241,2094.478Z",
    transform: "translate(-1039.045 -2093.565)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-auth-background"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2000
  })))), /*#__PURE__*/React.createElement("g", {
    id: "auth-background",
    clipPath: "url(#clip-auth-background)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_376",
    "data-name": "Grupo 376",
    transform: "translate(282.381 547.81)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M744.495,1323.587v43.087H714.331V1258.085h-87.1v91.967H562.685v-23h-9.14v23h-4.869v-23h-9.142v23H519.062l-21.817,33.732v90.72h-8.57V1312.19h-60.7v61.335l-55.425-.3v-119.1h-80.5v97.434l-27.712,36.486v157.718h-31.67V1411.7h-39.8V1391h-8.222v20.7H180.26V1391h-8.229v20.7H153.612l-19.64,30.359v189.356H812.607v-307.83Zm-581.079,121.4H149.558v-13.857h13.857Zm22.433,0H171.992v-13.857h13.856Zm18.263,0H190.253v-13.857h13.858Zm22.432,0H212.687v-13.857h13.856Zm-63.127,29.739H149.558v-13.857h13.857Zm22.433,0H171.992v-13.857h13.856Zm18.263,0H190.253v-13.857h13.858Zm22.432,0H212.687v-13.857h13.856Zm-63.127,29.292H149.558v-13.858h13.857Zm22.433,0H171.992v-13.858h13.856Zm18.263,0H190.253v-13.858h13.858Zm22.432,0H212.687v-13.858h13.856Zm73.85-107.6H286.535v-13.857h13.858Zm22.432,0H308.97v-13.857h13.856Zm18.263,0H327.23v-13.857h13.858Zm22.433,0H349.664v-13.857h13.856Zm37.487,0H387.149v-13.857h13.858Zm22.433,0H409.584v-13.857H423.44Zm18.262,0H427.844v-13.857H441.7Zm22.433,0H450.278v-13.857h13.856Zm-163.741,26.164H286.535v-13.857h13.858Zm22.432,0H308.97v-13.857h13.856Zm18.263,0H327.23v-13.857h13.858Zm22.433,0H349.664v-13.857h13.856Zm-47.388-52.658H302.276v-13.856h13.856Zm0-28.372H302.276V1327.7h13.856Zm0-28.372H302.276v-13.856h13.856Zm0-28.372H302.276v-13.856h13.856Zm22.434,85.116H324.71v-13.856h13.856Zm0-28.372H324.71V1327.7h13.856Zm0-28.372H324.71v-13.856h13.856Zm0-28.372H324.71v-13.856h13.856ZM361,1369.923H347.144v-13.856H361Zm0-28.372H347.144V1327.7H361Zm0-28.372H347.144v-13.856H361Zm0-28.372H347.144v-13.856H361Zm103.414,84.536H450.557v-13.856h13.858Zm0-28.373H450.557v-13.855h13.858Zm189.214,39.181H639.772V1366.3h13.856Zm0-28.371H639.772v-13.857h13.856Zm0-28.371H639.772V1309.55h13.856Zm0-28.374H639.772v-13.856h13.856Zm22.433,85.116H662.2V1366.3h13.856Zm0-28.371H662.2v-13.857h13.856Zm0-28.371H662.2V1309.55h13.856Zm0-28.374H662.2v-13.856h13.856Zm22.434,85.116H684.639V1366.3h13.856Zm0-28.371H684.639v-13.857h13.856Zm0-28.371H684.639V1309.55h13.856Zm0-28.374H684.639v-13.856h13.856Z",
    transform: "translate(-133.972 -947.163)",
    fill: "#eee"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(1053.309 197.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(0 24.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M2165.332,1450.812c-2.4,1.031-3.822,1.585-4.149,1.71l-7.051-18.3c2-.833,207.211-82.759,306.1-344.673l18.347,6.927c-53.326,141.247-136.54,230.418-196.958,280.349C2225.631,1423.1,2179.194,1444.866,2165.332,1450.812Z",
    transform: "translate(-2154.132 -1089.548)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(278.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M2736.954,1043.458l-49.376,34.527,61.36,24.52Z",
    transform: "translate(-2687.578 -1043.458)",
    fill: "#eee"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_148",
    "data-name": "Grupo 148",
    transform: "translate(481.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M1643.581,2141.028c-193.213,0-349.843,15.414-349.843,34.428a3.518,3.518,0,0,0,.055.584,530.848,530.848,0,0,0-65.271-3.9c-94.877,0-171.79,23.344-171.79,52.139s76.913,52.139,171.79,52.139,171.79-23.343,171.79-52.139c0-9.723-8.779-18.823-24.049-26.614,64.173,7.473,160.114,12.218,267.317,12.218,193.213,0,349.843-15.414,349.843-34.427S1836.794,2141.028,1643.581,2141.028Z",
    transform: "translate(-1056.733 -1371.635)",
    fill: "#28364c",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(542.339 513.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1",
    "data-name": "Ret\\xE2ngulo 1",
    width: 142.355,
    height: 143.095,
    transform: "translate(194.17)",
    fill: "#f1ac6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2",
    "data-name": "Ret\\xE2ngulo 2",
    width: 89.372,
    height: 204.823,
    transform: "translate(85.834 80.58)",
    fill: "#f1ac6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3",
    "data-name": "Ret\\xE2ngulo 3",
    width: 89.372,
    height: 204.823,
    transform: "translate(130.52 80.58)",
    fill: "#f3c084"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4",
    "data-name": "Ret\\xE2ngulo 4",
    width: 142.355,
    height: 143.095,
    transform: "translate(235.907)",
    fill: "#f3c084"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_5",
    "data-name": "Ret\\xE2ngulo 5",
    width: 142.355,
    height: 143.095,
    transform: "translate(193.49 142.308)",
    fill: "#f1ac6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_6",
    "data-name": "Ret\\xE2ngulo 6",
    width: 142.355,
    height: 143.095,
    transform: "translate(235.227 142.308)",
    fill: "#f3c084"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7",
    "data-name": "Ret\\xE2ngulo 7",
    width: 183.851,
    height: 76.959,
    transform: "translate(0 208.444)",
    fill: "#f1ac6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8",
    "data-name": "Ret\\xE2ngulo 8",
    width: 183.851,
    height: 76.959,
    transform: "translate(36.041 208.444)",
    fill: "#f3c084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M2724.363,1855.978H2582.008l-33.968,35.273H2690.4Z",
    transform: "translate(-2312.813 -1748.943)",
    fill: "#f1ac6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M2427.969,1855.978h41.737l20.868,35.273h-41.737Z",
    transform: "translate(-2255.347 -1748.943)",
    fill: "#c78b5b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    transform: "translate(102.32)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(179.781 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M2056.658,1410.426c0,33.341-36.7,62.537-61.764,64.168H1629.776a32,32,0,0,1-31.995-32V697.4a32,32,0,0,1,31.995-32l364.585.046c25.731,0,62.3,27.284,62.3,64.119Z",
    transform: "translate(-1597.781 -665.396)",
    fill: "#cbc7c7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(147.776 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M1995.286,1442.594a32,32,0,0,1-32,32H1568.4a32,32,0,0,1-32.005-32V697.4a32,32,0,0,1,32.005-32h394.883a32,32,0,0,1,32,32Z",
    transform: "translate(-1536.398 -665.396)",
    fill: "#e9e7e7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8",
    transform: "translate(185.207 42.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M1992.219,1396.937a26.787,26.787,0,0,1-26.787,26.777H1634.964a26.778,26.778,0,0,1-26.777-26.777V773.3a26.78,26.78,0,0,1,26.777-26.781h330.467a26.789,26.789,0,0,1,26.787,26.781Z",
    transform: "translate(-1608.187 -746.518)",
    fill: "#e8f6fd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M1536.4,751.94v22.324s265.393,51.616,318.8,13.3,142.615-93.847,142.615-93.847,9.108-11.509-20.5-26.479S1536.4,751.94,1536.4,751.94Z",
    transform: "translate(-1388.622 -665.542)",
    fill: "#28364c",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    transform: "translate(185.207 42.297)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M1965.431,746.518h-97.94a781.7,781.7,0,0,1-259.3,241.052v111.254c131.067-41.936,240.965-141.046,329.679-251.943,19.965-25.945,34.321-53.757,53.56-79.939A26.778,26.778,0,0,0,1965.431,746.518Z",
    transform: "translate(-1608.187 -746.518)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(296.157 745.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M1983.106,2112.96a18.134,18.134,0,0,1-18.136,18.136H1839.1a18.132,18.132,0,0,1-18.126-18.136h0a18.13,18.13,0,0,1,18.126-18.131H1964.97a18.132,18.132,0,0,1,18.136,18.131Z",
    transform: "translate(-1820.979 -2094.829)",
    fill: "#cbc7c7"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    transform: "translate(169.87 5.062)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M1582.348,681.271h403.311a26.876,26.876,0,0,1,3.587.246c-1.681-3.691-2.779-6.413-9.535-6.413H1586.148c-6.752,0-5.7,2.722-7.376,6.413A26.593,26.593,0,0,1,1582.348,681.271Z",
    transform: "translate(-1578.772 -675.105)",
    fill: "#e6e7e8"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(0.051 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M1837.845,665.4h-390l-194.773,71.45,474.812,13.609L1841.449,680.5C1846.912,677.138,1844.261,665.37,1837.845,665.4Z",
    transform: "translate(-1253.073 -665.396)",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(403.563 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M2212.15,680.311l-113.875,70.143-71.3-2.043,140.2-83.015h41.058C2214.549,665.371,2217.525,677,2212.15,680.311Z",
    transform: "translate(-2026.976 -665.396)",
    fill: "#37aa9c"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    transform: "translate(267.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M1965.344,665.4l-134.771,80.959-64.034-1.835L1909.013,665.4Z",
    transform: "translate(-1766.539 -665.396)",
    fill: "#37aa9c"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(139.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M1670.976,665.4l-151.035,75.438,63.835,1.83L1724.9,665.412Z",
    transform: "translate(-1519.941 -665.396)",
    fill: "#37aa9c"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17",
    transform: "translate(403.207 83.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M2097.949,826.655s-16.192,24.511-46.392,20.5-24.908-22.543-24.908-22.543Z",
    transform: "translate(-2026.293 -824.612)",
    fill: "#1a675c"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18",
    transform: "translate(267.221 79.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M1830.068,818.983S1819.1,840.5,1789.44,839.647s-23.406-22.5-23.406-22.5Z",
    transform: "translate(-1765.484 -817.148)",
    fill: "#1a675c"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    transform: "translate(139.192 75.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M1583.773,811.91a41.884,41.884,0,0,1-37.885,20.347c-26.854-.77-25.95-22.176-25.95-22.176Z",
    transform: "translate(-1519.934 -810.08)",
    fill: "#1a675c"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23",
    transform: "translate(68.089 73.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    transform: "translate(263.675 7.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M1961.07,822.724s-13.376,21.445-43.739,20.575-28.019-22.631-28.019-22.631Z",
    transform: "translate(-1889.271 -820.668)",
    fill: "#dad7ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    transform: "translate(134.938 3.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M1707.109,815.445s-8.832,21.575-37.256,20.761-27.485-22.616-27.485-22.616Z",
    transform: "translate(-1642.364 -813.589)",
    fill: "#dad7ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M1454.671,808.21s-9.664,21.552-41.33,20.644-29.755-22.681-29.755-22.681Z",
    transform: "translate(-1383.563 -806.172)",
    fill: "#dad7ba"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    transform: "translate(0 71.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M1321.086,804.382s-6.927,21.63-38.792,20.717-29.268-22.667-29.268-22.667Z",
    transform: "translate(-1252.975 -802.431)",
    fill: "#207066"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    transform: "translate(0 71.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(403.207 11.565)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M2097.949,826.389s-16.192,24.511-46.392,20.5-24.908-22.543-24.908-22.543Z",
    transform: "translate(-2026.293 -824.346)",
    fill: "#37aa9c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(267.221 7.673)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M1830.068,818.717s-10.968,21.514-40.628,20.664-23.406-22.5-23.406-22.5Z",
    transform: "translate(-1765.484 -816.882)",
    fill: "#37aa9c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    transform: "translate(139.192 3.988)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M1583.773,811.643a41.884,41.884,0,0,1-37.885,20.347c-26.854-.77-25.95-22.176-25.95-22.176Z",
    transform: "translate(-1519.934 -809.814)",
    fill: "#37aa9c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M1321.086,804.115s-6.927,21.63-38.792,20.717-29.268-22.667-29.268-22.667Z",
    transform: "translate(-1252.975 -802.165)",
    fill: "#37aa9c"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(0.051 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M1496.925,665.4h-51.133c-15.979,0-25.7,5.012-25.7,5.012l-167.024,66.438,68.06,1.95,148.659-62.484Z",
    transform: "translate(-1253.073 -665.396)",
    fill: "#37aa9c"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    transform: "translate(419.787 412.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M1975.719,1604.631h-87.466l-12.717-71.522h112.9Z",
    transform: "translate(-1868.4 -1493.02)",
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9",
    "data-name": "Ret\\xE2ngulo 9",
    width: 127.173,
    height: 14.475,
    transform: "translate(0 25.614)",
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(12.648)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_1",
    "data-name": "Linha 1",
    y1: 25.614,
    x2: 25.854,
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_2",
    "data-name": "Linha 2",
    x1: 25.854,
    y1: 25.614,
    transform: "translate(76.023)",
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35",
    transform: "translate(24.163 52.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_3",
    "data-name": "Linha 3",
    x2: 7.982,
    y2: 44.894,
    transform: "translate(0 0.439)",
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_4",
    "data-name": "Linha 4",
    x2: 5.899,
    y2: 44.894,
    transform: "translate(16.068 0.439)",
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_5",
    "data-name": "Linha 5",
    x2: 2.313,
    y2: 45.772,
    transform: "translate(31.846)",
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(44.689)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_6",
    "data-name": "Linha 6",
    x1: 7.983,
    y2: 44.894,
    transform: "translate(26.176 0.439)",
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_7",
    "data-name": "Linha 7",
    x1: 5.899,
    y2: 44.894,
    transform: "translate(12.192 0.439)",
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_8",
    "data-name": "Linha 8",
    x1: 2.313,
    y2: 45.772,
    fill: "none",
    stroke: "#2a344f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_49",
    "data-name": "Grupo 49",
    transform: "translate(347.889 253.944)"
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37",
    transform: "translate(35.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M1944.784,1288.771c-72.356,61.289-95.643,47.336-115.5,14.462s-36.872-70.071-36.872-70.071l15.793-11.08s49.271,45.984,54.694,45.984,97.083-90.666,140.231-115.624C2003.125,1152.44,1981.453,1257.71,1944.784,1288.771Z",
    transform: "translate(-1792.408 -1152.44)",
    fill: "#354649"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_41",
    "data-name": "Grupo 41",
    transform: "translate(0 22.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38",
    transform: "translate(17.251 13.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M1779.476,1224.727c8.508,7.336,11.49,20.207,6.648,28.749s-15.643,9.515-24.15,2.18-4.418-14.117.412-22.658S1770.966,1217.387,1779.476,1224.727Z",
    transform: "translate(-1757.04 -1221.661)",
    fill: "#00b0b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39",
    transform: "translate(0 0.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_33",
    "data-name": "Caminho 33",
    d: "M1759.825,1209.881l-14.621,33.381s-12.746-12.609-18.5-22.644a19.42,19.42,0,0,1-2.711-6.983c-.541-5.1,5.173-14.807,9.27-15.784,1.18-.275,2.818-.694,4.317.273C1746.543,1203.869,1758.533,1210.89,1759.825,1209.881Z",
    transform: "translate(-1723.954 -1197.52)",
    fill: "#00b0b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40",
    transform: "translate(33.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_34",
    "data-name": "Caminho 34",
    d: "M1792.208,1219.326l8.306.484-6.73-23.266s-4.483,3.075-4.671,4.419C1788.547,1205.014,1792.208,1219.326,1792.208,1219.326Z",
    transform: "translate(-1789.054 -1196.544)",
    fill: "#00b0b2"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42",
    transform: "translate(27.806 60.622)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_10",
    "data-name": "Ret\\xE2ngulo 10",
    width: 29.855,
    height: 9.467,
    rx: 4.733,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 0, 17.147)",
    fill: "#00b0b2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43",
    transform: "translate(31.741 63.141)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_35",
    "data-name": "Caminho 35",
    d: "M1801.746,1273.54l-16.914,11.868S1789.952,1274.922,1801.746,1273.54Z",
    transform: "translate(-1784.832 -1273.54)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(8.495 23.494)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_36",
    "data-name": "Caminho 36",
    d: "M1743.12,1197.511a42.465,42.465,0,0,0,5.883,14.057c4.85,7.761-9.514-10.918-8.724-13.448A7.73,7.73,0,0,1,1743.12,1197.511Z",
    transform: "translate(-1740.247 -1197.5)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_45",
    "data-name": "Grupo 45",
    transform: "translate(3.929 26.884)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37",
    "data-name": "Caminho 37",
    d: "M1732.808,1204s.03,8.168,3.248,10.223S1727.71,1211.583,1732.808,1204Z",
    transform: "translate(-1731.49 -1204.001)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(1.475 33.017)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M1726.794,1215.764s-.319,5.429,2.444,6.586S1727.58,1219.721,1726.794,1215.764Z",
    transform: "translate(-1726.782 -1215.764)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_47",
    "data-name": "Grupo 47",
    transform: "translate(32.695 68.592)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39",
    "data-name": "Caminho 39",
    d: "M1805.918,1283.994l-19.258,14.148S1796.768,1284.55,1805.918,1283.994Z",
    transform: "translate(-1786.66 -1283.994)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_48",
    "data-name": "Grupo 48",
    transform: "translate(24.782 30.92)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_40",
    "data-name": "Caminho 40",
    d: "M1777.552,1220.044c3.7,5.018,7.622,10.206,7,8.841-1.141-2.511-2.956-12.182-2.956-12.182l-10.112-4.962s2.835,3.921,5.871,8.037c-3.974,3.722-8.4,12.016,8.276,22C1785.632,1241.782,1772.065,1226.307,1777.552,1220.044Z",
    transform: "translate(-1771.485 -1211.742)",
    fill: "#28364c"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(479.543 237.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M2159.426,1122.436s-32.2-10.754-73.286,18.336-109.682,91.608-109.682,91.608l19.082,39.956,46.864-11.167,128.654,176.681,1.364-309.1Z",
    transform: "translate(-1976.457 -1120.493)",
    fill: "#354649"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_51",
    "data-name": "Grupo 51",
    transform: "translate(409.475 362.126)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M1965.806,1359.924s-65.422,61.2-90.988,48.709-32.744-25.132-32.744-25.132,14.751,25.292,17.241,28.484,16.207,21.5,35.6,18.433,37.865-13.989,53.3-26.113,24.328-18.059,30.48-27.067Z",
    transform: "translate(-1842.073 -1359.924)",
    fill: "#351313"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60",
    transform: "translate(415.48 277.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52",
    transform: "translate(131.428 30.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M2124.4,1282.486a4.809,4.809,0,0,1-.891-.076c-7.369-.969-12.795-5.821-15.689-14.03a40.69,40.69,0,0,1-2.163-12.183l.684,0a39.994,39.994,0,0,0,2.131,11.968c2.846,8.058,7.939,12.621,15.137,13.564l.032.006c.158.035,3.915.82,5.174-3.613l.659.187C2128.436,1281.97,2125.8,1282.486,2124.4,1282.486Z",
    transform: "translate(-2105.658 -1256.197)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_53",
    "data-name": "Grupo 53",
    transform: "translate(188.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M2221.019,1230.379a13.037,13.037,0,0,1-5.93-1.657l.347-.591c.056.033,5.631,3.243,9.56.31,2.083-1.555,4.5-5.463,5.189-10.686.6-4.5.155-11.689-5.338-20.419l.58-.364c10.25,16.292,4.277,28.809-.021,32.017A7.172,7.172,0,0,1,2221.019,1230.379Z",
    transform: "translate(-2215.089 -1196.972)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_54",
    "data-name": "Grupo 54",
    transform: "translate(171.797 43.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M2199.407,1305.244a.477.477,0,0,1-.086-.008c-.337-.063-1.036-.193-8.765-11.976-3.783-5.766-7.438-11.575-7.474-11.633l.579-.365c5.375,8.547,14.249,22.181,15.722,23.255,1.231-.846,6.4-3.806,6.628-3.937l.34.594c-.058.033-5.811,3.328-6.694,3.988A.419.419,0,0,1,2199.407,1305.244Z",
    transform: "translate(-2183.083 -1281.263)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55",
    "data-name": "Grupo 55",
    transform: "translate(180.872 38.852)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 3.733,
    cy: 3.733,
    r: 3.733,
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56",
    "data-name": "Grupo 56",
    transform: "translate(189.756 50.754)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    cx: 3.733,
    cy: 3.733,
    r: 3.733,
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57",
    transform: "translate(113.846 80.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_11",
    "data-name": "Ret\\xE2ngulo 11",
    width: 1.369,
    height: 126.229,
    transform: "matrix(0.802, -0.597, 0.597, 0.802, 0, 0.818)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    "data-name": "Grupo 58",
    transform: "translate(21.538 29.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M1896.151,1337.523l-1.253-.992,16.469-20.778.056-.049,71.865-62.465,1.048,1.206-71.809,62.416Z",
    transform: "translate(-1894.898 -1253.239)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59",
    transform: "translate(0 61.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M1891.69,1346.074c-.275-.211-27.578-21.2-38.1-30.782l1.075-1.182c10.473,9.539,37.724,30.486,38,30.7Z",
    transform: "translate(-1853.59 -1314.11)",
    fill: "#28364c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_95",
    "data-name": "Grupo 95",
    transform: "translate(450.37 159.467)"
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61",
    transform: "translate(82.838 59.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M2121.031,1086.2l33.876,59.028-53.954,30.965-21.571-37.586S2118.446,1081.694,2121.031,1086.2Z",
    transform: "translate(-2079.382 -1085.944)",
    fill: "#cc632a"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_62",
    "data-name": "Grupo 62",
    transform: "translate(121.247 36.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M2153.047,1041.5s8.227,25.635,8.564,32.7l-6.461-11.259Z",
    transform: "translate(-2153.047 -1041.5)",
    fill: "#1a2229"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_63",
    "data-name": "Grupo 63",
    transform: "translate(95.743 103.988)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 31.104,
    cy: 18.521,
    rx: 31.104,
    ry: 18.521,
    transform: "translate(0 30.965) rotate(-29.852)",
    fill: "#cc632a"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    transform: "translate(27.833 2.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M2006.571,1078.215s-24.553-26.348-31.941-55.655,42.121-61.357,68.167-37.1,33.6,46.83,18.372,84.958S2006.571,1078.215,2006.571,1078.215Z",
    transform: "translate(-1973.887 -976.901)",
    fill: "#cc632a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "translate(33.004 39.691)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M1991.466,1084.647s28.059-21.253,52.022-37.283l-59.685,22.223S1989.122,1081.583,1991.466,1084.647Z",
    transform: "translate(-1983.803 -1047.364)",
    fill: "#cc632a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66",
    transform: "translate(87.84 60.06)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M2100.106,1166.948s17.693-2.064,24.237-26.237,1.279-54.28,1.279-54.28-11.457,58-36.647,61.123Z",
    transform: "translate(-2088.975 -1086.431)",
    fill: "#cc632a"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67",
    transform: "translate(105.258 31.495)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 13.233,
    cy: 11.67,
    rx: 13.233,
    ry: 11.67,
    transform: "translate(0 13.174) rotate(-29.852)",
    fill: "#cc632a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    "data-name": "Grupo 82",
    transform: "translate(60.31 39.751)"
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_69",
    "data-name": "Grupo 69",
    transform: "translate(0.207 35.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M2036.572,1144.362l9.2-9.4a39.859,39.859,0,0,1,7.617-6.084l10.95-6.736a39.888,39.888,0,0,1,12.232-4.96l9.3-2.07,5.074,8.249a11.535,11.535,0,0,1,1.337,8.948l-2.255,8.659a27.159,27.159,0,0,1-12.054,16.289h0a27.16,27.16,0,0,1-20.386,3.32l-8.2-1.908a11.531,11.531,0,0,1-7.209-5.189Z",
    transform: "translate(-2036.572 -1115.11)",
    fill: "#00b0b2"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_71",
    "data-name": "Grupo 71",
    transform: "translate(0 35.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_70",
    "data-name": "Grupo 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M2042.071,1153.45a.164.164,0,0,1-.222-.056l-5.674-9.225,9.285-9.493a40.076,40.076,0,0,1,7.648-6.109l10.95-6.735a39.929,39.929,0,0,1,12.283-4.981l9.416-2.1,5.135,8.348a.165.165,0,0,1-.054.226.163.163,0,0,1-.226-.054l-5.013-8.15-9.187,2.045a39.592,39.592,0,0,0-12.182,4.94l-10.95,6.735a39.767,39.767,0,0,0-7.586,6.059l-9.106,9.31,5.54,9.007a.164.164,0,0,1-.054.226Z",
    transform: "translate(-2036.175 -1114.754)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    transform: "translate(6.935 42.203)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M2093.423,1128.42c-2.089.577-4.192,1.093-6.287,1.641a43.45,43.45,0,0,0-6.13,1.977,41.668,41.668,0,0,0-5.738,2.878l-5.514,3.415-5.545,3.381a42.6,42.6,0,0,0-5.279,3.664c-.835.673-1.633,1.391-2.416,2.126l-2.327,2.259c-1.572,1.491-3.119,3.005-4.711,4.476,1.435-1.624,2.915-3.2,4.371-4.808l2.22-2.378q1.137-1.177,2.377-2.253a39.089,39.089,0,0,1,5.285-3.867l5.518-3.424c1.853-1.125,3.682-2.261,5.556-3.377a38.3,38.3,0,0,1,12.231-4.528C2089.164,1129.208,2091.287,1128.784,2093.423,1128.42Z",
    transform: "translate(-2049.475 -1128.42)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77",
    transform: "translate(11.639 51.219)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_76",
    "data-name": "Grupo 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M2058.5,1171.529c2.089-.577,4.192-1.093,6.287-1.642a43.424,43.424,0,0,0,6.13-1.977,41.69,41.69,0,0,0,5.738-2.878l5.514-3.415,5.545-3.381a42.64,42.64,0,0,0,5.279-3.664c.834-.673,1.633-1.391,2.416-2.126l2.328-2.259c1.572-1.491,3.118-3.006,4.711-4.476-1.436,1.624-2.915,3.2-4.372,4.808l-2.22,2.378q-1.137,1.177-2.376,2.253a39.173,39.173,0,0,1-5.285,3.867l-5.518,3.424c-1.854,1.125-3.682,2.261-5.556,3.377a38.265,38.265,0,0,1-12.231,4.528C2062.758,1170.74,2060.635,1171.165,2058.5,1171.529Z",
    transform: "translate(-2058.498 -1145.712)",
    fill: "#fff"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79",
    "data-name": "Grupo 79",
    transform: "translate(55.954 20.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78",
    "data-name": "Grupo 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M2143.737,1113.719a.161.161,0,0,1-.128.015.164.164,0,0,1-.112-.2l8.058-27.3a.164.164,0,0,1,.315.093l-8.058,27.3A.166.166,0,0,1,2143.737,1113.719Z",
    transform: "translate(-2143.49 -1086.116)",
    fill: "#fff"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    "data-name": "Grupo 81",
    transform: "translate(49.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_80",
    "data-name": "Grupo 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M2131.048,1082.884a.162.162,0,0,1-.111.019.165.165,0,0,1-.133-.191l6.457-35.1a.164.164,0,1,1,.323.059l-6.457,35.1A.163.163,0,0,1,2131.048,1082.884Z",
    transform: "translate(-2130.802 -1047.479)",
    fill: "#fff"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83",
    transform: "translate(25.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M1975.4,1027.026c1.627-2.737,4.522-3.5,15.652-9.884a197.666,197.666,0,0,1,37.95-16.907c11.819-3.688,21.607-4.908,26.108-2.436,1.421-.035-1.22-8.534-4.166-14.042-.148-.317-.312-.6-.475-.885a21.7,21.7,0,0,0-4.7-5.673c-8.253-7.019-22.752-8.724-42.528-.249-.075.043-.165.058-.2.079-2.206.95-4.47,2.029-6.825,3.236-.832.428-1.627.86-2.413,1.311a58.291,58.291,0,0,0-11.978,8.75c-.225.215-.45.429-.652.655-8.023,7.991-10.8,16.491-10.926,23.142C1970.059,1022.343,1973.646,1027.9,1975.4,1027.026Z",
    transform: "translate(-1970.24 -971.24)",
    fill: "#354649"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_84",
    "data-name": "Grupo 84",
    transform: "translate(0 55.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M1935.476,1085.973c4.973-2.543,10.084-6.126,15.8-9.18,1.416,6.439,4.856,12.5,8.356,19.419h0C1924.862,1118.551,1905.117,1101.5,1935.476,1085.973Z",
    transform: "translate(-1920.505 -1076.793)",
    fill: "#354649"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_85",
    "data-name": "Grupo 85",
    transform: "translate(6.869 25.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M1933.679,1063.55c11.5-6.989,18.662-3.689,47.778-9.784,22.095-4.613,43.036-23.444,54.235-33.642-19.731-4.99-61.754,19.36-86.5,33.329A184.829,184.829,0,0,0,1933.679,1063.55Z",
    transform: "translate(-1933.679 -1019.461)",
    fill: "#576e72"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_90",
    "data-name": "Grupo 90",
    transform: "translate(51.839 58.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    "data-name": "Grupo 87",
    transform: "translate(29.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    "data-name": "Grupo 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M2076.99,1090.95a3.275,3.275,0,0,1,.4-1.665,11.033,11.033,0,0,1,9.082-6.126,5.42,5.42,0,0,0-1.607.766c-.029.022-.047.047-.074.069a5.551,5.551,0,0,0-.868.659,11.771,11.771,0,0,0-2.239,3.287,17.252,17.252,0,0,1-2.063,3.41,1.9,1.9,0,0,1-1.63.846A1.358,1.358,0,0,1,2076.99,1090.95Z",
    transform: "translate(-2076.982 -1083.159)",
    fill: "#1a2229"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    "data-name": "Grupo 89",
    transform: "translate(0 18.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    "data-name": "Grupo 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M2030.22,1118.81a3.274,3.274,0,0,0-1.708-.121,11.032,11.032,0,0,0-8.584,6.8,5.416,5.416,0,0,1,1.216-1.3c.03-.021.059-.031.088-.049a5.511,5.511,0,0,1,.891-.629,11.78,11.78,0,0,1,3.81-1.14,17.252,17.252,0,0,0,3.875-.935c.593-.252,1.218-.667,1.3-1.3A1.358,1.358,0,0,0,2030.22,1118.81Z",
    transform: "translate(-2019.927 -1118.634)",
    fill: "#1a2229"
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    "data-name": "Grupo 91",
    transform: "translate(73.045 76.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M2065.752,1130.508l-.9-.142c.012-.078,1.16-7.823-4.251-10.651l.423-.809C2067.019,1122.039,2065.806,1130.163,2065.752,1130.508Z",
    transform: "translate(-2060.599 -1118.905)",
    fill: "#1a2229"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    "data-name": "Grupo 92",
    transform: "translate(85.51 68.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M2085.325,1108.381l-.819-.4c2.994-6.068,11.144-5.045,11.489-5l-.121.9C2095.8,1103.872,2088.027,1102.905,2085.325,1108.381Z",
    transform: "translate(-2084.506 -1102.886)",
    fill: "#1a2229"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    "data-name": "Grupo 93",
    transform: "translate(57.858 85.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M2032.373,1144.413l-.9-.145c.055-.344,1.433-8.442,8.106-9.554l.15.9C2033.7,1136.62,2032.386,1144.335,2032.373,1144.413Z",
    transform: "translate(-2031.472 -1134.714)",
    fill: "#1a2229"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_94",
    "data-name": "Grupo 94",
    transform: "translate(91.429 13.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M2095.858,1024.237s4.083,2.3,11.583-2.008,12.175,20.889,16.041,21.915-6.736-19-1.476-22.843a16.854,16.854,0,0,1,3.671-1.068s-10.023-19.833-14.123-23.169c0,0,4.6,10.016,3.677,13.095a5.189,5.189,0,0,0-1.919-.753S2101.715,1019.96,2095.858,1024.237Z",
    transform: "translate(-2095.858 -997.063)",
    fill: "#1a2229"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    "data-name": "Grupo 96",
    transform: "translate(605.236 281.599)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M2286.432,1478.526l-68.906-95.733,34.611-124.916v-52.4s1.5,25.588,21.777,38.149,25.86,113.069,25.86,113.069l-12.984,34.032Z",
    transform: "translate(-2217.526 -1205.48)",
    fill: "#351313"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_137",
    "data-name": "Grupo 137",
    transform: "translate(604.605 317.9)"
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_105",
    "data-name": "Grupo 105",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    "data-name": "Grupo 97"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_12",
    "data-name": "Ret\\xE2ngulo 12",
    width: 146.034,
    height: 171.977,
    transform: "translate(0 145.895) rotate(-87.497)",
    fill: "#f1ac6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    "data-name": "Grupo 98",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_13",
    "data-name": "Ret\\xE2ngulo 13",
    width: 146.034,
    height: 113.58,
    transform: "translate(0 145.895) rotate(-87.497)",
    fill: "#f4c085"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99",
    transform: "translate(140.819 5.932)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_14",
    "data-name": "Ret\\xE2ngulo 14",
    width: 29.274,
    height: 17.144,
    transform: "matrix(0.044, -0.999, 0.999, 0.044, 0, 29.246)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    "data-name": "Grupo 100",
    transform: "translate(140.819 35.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M2486.394,1342.57l1.612,4.189,1.709-4.044Z",
    transform: "translate(-2486.394 -1342.57)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_101",
    "data-name": "Grupo 101",
    transform: "translate(144.259 35.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M2492.993,1342.82l1.612,4.189,1.709-4.044Z",
    transform: "translate(-2492.993 -1342.82)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_102",
    "data-name": "Grupo 102",
    transform: "translate(147.7 35.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M2499.592,1343.07l1.612,4.189,1.709-4.044Z",
    transform: "translate(-2499.592 -1343.07)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_103",
    "data-name": "Grupo 103",
    transform: "translate(151.294 35.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_72",
    "data-name": "Caminho 72",
    d: "M2506.485,1343.242l1.612,4.189,1.709-4.044Z",
    transform: "translate(-2506.485 -1343.242)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_104",
    "data-name": "Grupo 104",
    transform: "translate(154.644 35.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_73",
    "data-name": "Caminho 73",
    d: "M2512.909,1343.632l1.612,4.189,1.709-4.044Z",
    transform: "translate(-2512.909 -1343.632)",
    fill: "#f5f6f6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_136",
    "data-name": "Grupo 136",
    transform: "translate(32.622 124.023)",
    opacity: 0.61,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_117",
    "data-name": "Grupo 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_107",
    "data-name": "Grupo 107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_106",
    "data-name": "Grupo 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_74",
    "data-name": "Caminho 74",
    d: "M2294.16,1530.853l-13.448-.605a1.916,1.916,0,0,1-1.828-2l.6-13.447a1.917,1.917,0,0,1,2-1.83l13.447.605a1.917,1.917,0,0,1,1.829,2l-.605,13.447A1.917,1.917,0,0,1,2294.16,1530.853Zm-12.691-17.414a1.446,1.446,0,0,0-1.512,1.382l-.605,13.447a1.447,1.447,0,0,0,1.382,1.512l13.447.605a1.454,1.454,0,0,0,1.511-1.381l.605-13.447a1.455,1.455,0,0,0-1.381-1.512Z",
    transform: "translate(-2278.882 -1512.968)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_116",
    "data-name": "Grupo 116",
    transform: "translate(2.62 2.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_108",
    "data-name": "Grupo 108",
    transform: "translate(0 9.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_15",
    "data-name": "Ret\\xE2ngulo 15",
    width: 2.031,
    height: 12.113,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 0, 2.029)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_115",
    "data-name": "Grupo 115",
    transform: "translate(2.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_111",
    "data-name": "Grupo 111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_109",
    "data-name": "Grupo 109",
    transform: "translate(0.676 3.245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16",
    "data-name": "Ret\\xE2ngulo 16",
    width: 6.207,
    height: 2.031,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 0, 6.201)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_110",
    "data-name": "Grupo 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_75",
    "data-name": "Caminho 75",
    d: "M2288.063,1521.612l2.118-3.314,1.812,3.491Z",
    transform: "translate(-2288.063 -1518.298)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_114",
    "data-name": "Grupo 114",
    transform: "translate(4.622 0.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_112",
    "data-name": "Grupo 112",
    transform: "translate(0.676 3.245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17",
    "data-name": "Ret\\xE2ngulo 17",
    width: 6.207,
    height: 2.031,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 0, 6.201)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_113",
    "data-name": "Grupo 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_76",
    "data-name": "Caminho 76",
    d: "M2296.928,1522.011l2.118-3.314,1.811,3.491Z",
    transform: "translate(-2296.928 -1518.697)",
    fill: "#28364c"
  }))))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_121",
    "data-name": "Grupo 121",
    transform: "translate(19.386 0.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_119",
    "data-name": "Grupo 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_118",
    "data-name": "Grupo 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_77",
    "data-name": "Caminho 77",
    d: "M2331.341,1532.526l-13.447-.605a1.916,1.916,0,0,1-1.829-2l.605-13.447a1.916,1.916,0,0,1,2-1.829l13.447.6a1.917,1.917,0,0,1,1.829,2l-.605,13.447A1.917,1.917,0,0,1,2331.341,1532.526Zm-12.69-17.414a1.445,1.445,0,0,0-1.511,1.381l-.605,13.447a1.446,1.446,0,0,0,1.381,1.511l13.448.605a1.456,1.456,0,0,0,1.511-1.382l.6-13.447a1.454,1.454,0,0,0-1.381-1.511Z",
    transform: "translate(-2316.063 -1514.642)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    transform: "translate(5.726 3.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_78",
    "data-name": "Caminho 78",
    d: "M2330.478,1522.259l-.81,1.065.557.012-1.315,1.894.489-1.606-.554-.025.86-1.375-2.457-.11-.2,4.458c-.055,1.222,1.13,2.284,2.715,2.506l-.113,2.51-1.224-.055c-.511-.023-.937.21-.952.52l5.13.231c.013-.31-.39-.581-.9-.6l-1.224-.055.113-2.51c1.6-.079,2.874-1.031,2.929-2.252l.2-4.459Z",
    transform: "translate(-2327.045 -1522.113)",
    fill: "#343434"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_135",
    "data-name": "Grupo 135",
    transform: "translate(38.773 1.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_122",
    "data-name": "Grupo 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_79",
    "data-name": "Caminho 79",
    d: "M2368.523,1534.2l-13.447-.6a1.917,1.917,0,0,1-1.829-2l.605-13.447a1.917,1.917,0,0,1,2-1.829l13.447.605a1.917,1.917,0,0,1,1.829,2l-.605,13.447A1.916,1.916,0,0,1,2368.523,1534.2Zm-12.69-17.414a1.446,1.446,0,0,0-1.511,1.382l-.605,13.447a1.446,1.446,0,0,0,1.381,1.511l13.447.605a1.455,1.455,0,0,0,1.512-1.382l.605-13.447a1.455,1.455,0,0,0-1.382-1.511Z",
    transform: "translate(-2353.245 -1516.315)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_134",
    "data-name": "Grupo 134",
    transform: "translate(3.782 4.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_124",
    "data-name": "Grupo 124",
    transform: "translate(5.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_80",
    "data-name": "Caminho 80",
    d: "M2370.556,1525.037a.132.132,0,0,0-.139.123l-.019.415.268.012.019-.415A.133.133,0,0,0,2370.556,1525.037Z",
    transform: "translate(-2370.398 -1525.037)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_133",
    "data-name": "Grupo 133",
    transform: "translate(0 0.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125",
    transform: "translate(0 0.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81",
    "data-name": "Caminho 81",
    d: "M2363,1530.076l.042,0,.052,0a2.1,2.1,0,0,1,2.464.111l.041,0a2.077,2.077,0,0,1,2.461.111l.042,0,.052,0a2.061,2.061,0,0,1,2.455.11l.09,0a5.125,5.125,0,0,0-10.2-.459l.042,0A2.062,2.062,0,0,1,2363,1530.076Z",
    transform: "translate(-2360.499 -1525.538)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126",
    transform: "translate(2.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M2365.261,1530.03c0-.038-.149-3.695,2.816-4.537l.016.063c-2.907.831-2.763,4.435-2.755,4.469Z",
    transform: "translate(-2365.26 -1525.493)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127",
    transform: "translate(5.248 0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M2372.983,1530.295l-.076-.014c.011-.033.478-3.609-2.343-4.693l.022-.062C2373.464,1526.632,2372.994,1530.261,2372.983,1530.295Z",
    transform: "translate(-2370.564 -1525.527)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_131",
    "data-name": "Grupo 131",
    transform: "translate(4.682 3.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128",
    "data-name": "Grupo 128",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_18",
    "data-name": "Ret\\xE2ngulo 18",
    width: 5.815,
    height: 0.287,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 0, 5.81)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    "data-name": "Grupo 129",
    transform: "translate(0.699 5.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M2370.821,1543.995",
    transform: "translate(-2370.821 -1543.995)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_130",
    "data-name": "Grupo 130",
    transform: "translate(0 5.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M2370.763,1543.086l-.013.287v.009l-.009.21a.483.483,0,0,1-.5.47.492.492,0,0,1-.474-.514l.009-.21v-.009l.012-.287-.286-.012-.023.506a.774.774,0,1,0,1.547.069l.022-.506Z",
    transform: "translate(-2369.479 -1543.03)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_132",
    "data-name": "Grupo 132",
    transform: "translate(5.012 0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M2370.189,1530.217l-.076,0,.218-4.625.067,0Z",
    transform: "translate(-2370.113 -1525.589)",
    fill: "#fff"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_138",
    "data-name": "Grupo 138",
    transform: "translate(659.665 313.011)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M2333.81,1280.118s52.323,8.52,51.2,34.15,15.786,106.683,15.786,106.683l24.809-132.853S2280.118,1243.6,2333.81,1280.118Z",
    transform: "translate(-2321.916 -1265.725)",
    fill: "#351313"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_139",
    "data-name": "Grupo 139",
    transform: "translate(752.651 372.201)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_88",
    "data-name": "Caminho 88",
    d: "M2500.256,1477.311l23.766,1.039,3.846-99.1Z",
    transform: "translate(-2500.256 -1379.245)",
    fill: "#351313"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_140",
    "data-name": "Grupo 140",
    transform: "translate(623.03 237.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M2410.927,1186.878l-114.172-61.531a32.519,32.519,0,0,0-5.62-2.342,30.554,30.554,0,0,0-38.848,35.14,17.732,17.732,0,0,0-.581,6.282c3.269,49.694,130.883,60.189,130.883,60.189l.34,1.625-18.229,117.11a10.794,10.794,0,0,0,21.134,4.293l35.5-141.159h0a16.337,16.337,0,0,0-8.092-18.359Z",
    transform: "translate(-2251.653 -1121.68)",
    fill: "#354649"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_141",
    "data-name": "Grupo 141",
    transform: "translate(639.838 275.168)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M2283.9,1233.993l-.009-40.847s46.878,46.072,107.245,52.748c0,0,26.127-27.74,28.867-11.9s-35.359,114.561-35.359,114.561l14.313-89.735S2325.618,1254.221,2283.9,1233.993Z",
    transform: "translate(-2283.89 -1193.146)",
    fill: "#351313"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142",
    transform: "translate(639.153 249.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M2397.318,1235.716c-31.557-3.263-55.029-8.835-69.163-12.935-15.336-4.449-23.322-8.183-23.4-8.22l-.1-.056a60.764,60.764,0,0,1-10.256-9.551c-4.791-5.557-10.708-14.455-11.682-25.292-1.109-12.326,4.263-24.509,15.966-36.212l.968.968c-11.4,11.4-16.638,23.213-15.571,35.113.938,10.464,6.679,19.1,11.33,24.5a61.12,61.12,0,0,0,9.979,9.318c.711.328,8.59,3.9,23.191,8.132,14.073,4.079,37.446,9.625,68.877,12.875Z",
    transform: "translate(-2282.576 -1143.449)",
    fill: "#28364c"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_143",
    "data-name": "Grupo 143",
    transform: "translate(753.658 317.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_92",
    "data-name": "Caminho 92",
    d: "M2503.482,1299.335l-1.3-.442c.271-.8,6.755-19.549,16.806-24.948l.649,1.207C2510.059,1280.3,2503.547,1299.145,2503.482,1299.335Z",
    transform: "translate(-2502.186 -1273.945)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    transform: "translate(707.925 449.008)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M2445.661,1538.025s-7.782-1.213-11.755-.973-3.923,2.365-3.923,2.365l4.917,5.094s-8.675,3.018-10.357,4.031-8.461.484-8.461.484-2.311-1.562-1.393,4.44,6.181,14.3,6.181,14.3,3.925,4,11.929,3.179,21.219-14.63,21.219-14.63l.9-9.069Z",
    transform: "translate(-2414.474 -1531.564)",
    fill: "#00b0b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M2426.845,1557.972c3.281-1.4,12.247-5.649,12.247-5.649l-4.192-.938s-8.676,3.018-10.357,4.031-8.461.484-8.461.484-2.311-1.562-1.393,4.44c.013.081.029.165.043.247C2418.883,1559.911,2424.8,1558.846,2426.845,1557.972Z",
    transform: "translate(-2414.474 -1538.439)",
    fill: "#28364c",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M2432.207,1583.565l10.805.535,12.256-8.983-1.393-1.5-11.569,9.312Z",
    transform: "translate(-2422.961 -1549.079)",
    fill: "#28364c",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M2421.336,1576.779l10.805.535,12.256-8.983-1.393-1.5-11.569,9.312Z",
    transform: "translate(-2417.758 -1545.831)",
    fill: "#28364c",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M2457.5,1532.085s-2.178-3.682.832-5.345,22.687,8.006,22.344,22.29-8.674-.783-10.386-4.093S2468.448,1537.495,2457.5,1532.085Z",
    transform: "translate(-2434.701 -1526.555)",
    fill: "#00b0b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M2458.2,1537.162s11.113,7.644,11.21,12.017,5.536,7.206,5.536,7.206S2474.511,1543.028,2458.2,1537.162Z",
    transform: "translate(-2435.4 -1531.631)",
    fill: "#28364c",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146",
    transform: "translate(354.561 555.971)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_19",
    "data-name": "Ret\\xE2ngulo 19",
    width: 90.561,
    height: 90.561,
    fill: "#d63332"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145",
    "data-name": "Grupo 145",
    transform: "translate(28.701 28.701)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_9",
    "data-name": "Linha 9",
    x2: 33.16,
    y2: 33.16,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_10",
    "data-name": "Linha 10",
    x1: 33.16,
    y2: 33.16,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147",
    "data-name": "Grupo 147",
    transform: "translate(512.312 555.971)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_20",
    "data-name": "Ret\\xE2ngulo 20",
    width: 90.561,
    height: 90.561,
    fill: "#5cbd80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_99",
    "data-name": "Caminho 99",
    d: "M2093.365,1794.745l16.78,22.67,22.392-34.179",
    transform: "translate(-2065.178 -1756.366)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_21",
    "data-name": "Ret\\xE2ngulo 21",
    width: 247.663,
    height: 7.375,
    rx: 3.688,
    transform: "translate(355.115 667.935)",
    fill: "#2a344f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_22",
    "data-name": "Ret\\xE2ngulo 22",
    width: 247.663,
    height: 7.375,
    rx: 3.687,
    transform: "translate(355.115 680.975)",
    fill: "#2a344f"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 179.84,
    cy: 5.608,
    rx: 179.84,
    ry: 5.608,
    transform: "translate(143.395 806.502)",
    fill: "#28364c",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_149",
    "data-name": "Grupo 149",
    transform: "translate(131.893 639.802)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_23",
    "data-name": "Ret\\xE2ngulo 23",
    width: 27.941,
    height: 141.77,
    transform: "translate(13.572 29.673)",
    fill: "#cc8c2a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_24",
    "data-name": "Ret\\xE2ngulo 24",
    width: 27.941,
    height: 141.77,
    transform: "translate(371.119 29.673)",
    fill: "#cc8c2a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_25",
    "data-name": "Ret\\xE2ngulo 25",
    width: 411.349,
    height: 40.663,
    transform: "translate(0)",
    fill: "#dea126"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_150",
    "data-name": "Grupo 150",
    transform: "translate(37.638 209.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_100",
    "data-name": "Caminho 100",
    d: "M805,1196.112a20.242,20.242,0,0,0-20.242,20.242c0,11.179,20.242,38.284,20.242,38.284s20.242-27.1,20.242-38.284A20.242,20.242,0,0,0,805,1196.112Zm0,27.283a7.921,7.921,0,1,1,7.921-7.921A7.921,7.921,0,0,1,805,1223.395Z",
    transform: "translate(-483.075 -1128.882)",
    fill: "#155f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_101",
    "data-name": "Caminho 101",
    d: "M238.5,1284.783a32.344,32.344,0,0,0-32.344,32.344c0,17.863,32.344,61.17,32.344,61.17s32.342-43.307,32.342-61.17A32.343,32.343,0,0,0,238.5,1284.783Zm0,43.593a12.655,12.655,0,1,1,12.655-12.655A12.656,12.656,0,0,1,238.5,1328.376Z",
    transform: "translate(-206.158 -1171.32)",
    fill: "#37aa9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_102",
    "data-name": "Caminho 102",
    d: "M1161.9,1067.171a26.242,26.242,0,0,0-26.241,26.241c0,14.494,26.241,49.631,26.241,49.631s26.241-35.137,26.241-49.631A26.242,26.242,0,0,0,1161.9,1067.171Zm0,35.369a10.268,10.268,0,1,1,10.268-10.267A10.267,10.267,0,0,1,1161.9,1102.54Z",
    transform: "translate(-651.016 -1067.171)",
    fill: "#cececd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_268",
    "data-name": "Grupo 268",
    transform: "translate(471.904 422.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_267",
    "data-name": "Grupo 267",
    transform: "translate(0 0)"
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151",
    "data-name": "Grupo 151",
    transform: "translate(69.038 314.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_103",
    "data-name": "Caminho 103",
    d: "M1173.279,2108.327c3.418-1.572,10.448-1.179,36.407-18.863s124.024-8.253,158.7,20.828-124.092,86.517-153.565,62.122S1173.279,2108.327,1173.279,2108.327Z",
    transform: "translate(-1172.328 -2079.746)",
    fill: "#243f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_104",
    "data-name": "Caminho 104",
    d: "M1238.122,2178.367c-11.516,0-19.8-2.036-24.68-6.073-15.327-12.687-25.871-29.535-32.018-41.436a153.919,153.919,0,0,1-9.769-23.027l-.2-.656.623-.286a19.129,19.129,0,0,1,2.6-.876c4.17-1.208,12.846-3.723,33.69-17.923,6.316-4.3,17.121-7.217,31.247-8.429a229.433,229.433,0,0,1,45.368,1.175c36.056,4.25,67.095,14.765,83.029,28.129,6.867,5.76,6.933,13.079.193,21.169-5.767,6.921-16.511,14.411-31.071,21.659a283.048,283.048,0,0,1-46.308,17.729c-17.025,4.9-33.024,7.9-46.267,8.654Q1241.19,2178.366,1238.122,2178.367Zm-64.745-70.308a158.021,158.021,0,0,0,9.459,22.108c6.078,11.761,16.495,28.406,31.608,40.916,10.395,8.6,39.5,7.427,75.948-3.072,34.792-10.021,65.578-25.647,76.607-38.884,6.171-7.406,6.172-13.784,0-18.958-15.709-13.176-46.439-23.558-82.2-27.773-33.809-3.984-63.463-1.24-75.546,6.992-21.051,14.341-29.89,16.9-34.137,18.134C1174.445,2107.717,1173.868,2107.884,1173.377,2108.059Z",
    transform: "translate(-1171.454 -2079.021)",
    fill: "#293033"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_161",
    "data-name": "Grupo 161",
    transform: "translate(69.073 400.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    "data-name": "Grupo 152",
    transform: "translate(0.37 0.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_105",
    "data-name": "Caminho 105",
    d: "M1197.91,2247.167c10.2,3.517,21.117,9.736,27.95,17.277,0,0,15.269-1.863,35.66-12.667l10.035,23.625c-21.7,8.84-31.7,16.814-31.78,16.882a20.913,20.913,0,0,1-1.309,3.527c-3.729,7.953-29.781,7.649-44.237-7.534-12.33-12.937-22.867-34-21.941-38.759C1173.614,2242.634,1185.083,2242.749,1197.91,2247.167Z",
    transform: "translate(-1172.231 -2244.062)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155",
    "data-name": "Grupo 155",
    transform: "translate(0.37 0.245)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153",
    transform: "translate(-0.37 -11.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_106",
    "data-name": "Caminho 106",
    d: "M1174.794,2248.885s39.14,14.918,41.656,19.372,6.446,11.514,15.354,9.688,14.41-1.565,15.458-6.019,15.2,6.019,15.2,6.019l11.333-30.475-15.263-15.368-62.094-10.218-24.913,11.319Z",
    transform: "translate(-1171.521 -2221.883)",
    fill: "#293033"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_157",
    "data-name": "Grupo 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_156",
    "data-name": "Grupo 156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_108",
    "data-name": "Caminho 108",
    d: "M1193.57,2288.335l.638-.568c-11.054-12.427-16.4-22.232-18.942-28.27-2.612-6.208-2.87-9.809-2.89-10.186a4.861,4.861,0,0,1,2.178-3c2.28-1.591,7.172-2.983,17.535-.574,9.888,2.3,18.365,7.279,23.734,11.052a73.406,73.406,0,0,1,9.392,7.727l.17.175.237-.058c21.6-5.268,35.619-12.63,35.759-12.7l-.4-.754c-.138.073-13.967,7.334-35.328,12.571a76.444,76.444,0,0,0-9.322-7.644c-5.435-3.821-14.019-8.865-24.049-11.2-10.7-2.489-15.837-.976-18.254.731a5.6,5.6,0,0,0-2.5,3.607l0,.06c0,.152.136,3.794,2.929,10.454C1177.011,2265.867,1182.407,2275.785,1193.57,2288.335Z",
    transform: "translate(-1171.521 -2243.593)",
    fill: "#293033"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_159",
    "data-name": "Grupo 159",
    transform: "translate(82.512 1.579)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_26",
    "data-name": "Ret\\xE2ngulo 26",
    width: 30.983,
    height: 15.554,
    rx: 7.777,
    transform: "translate(12.285 34.611) rotate(-113.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_109",
    "data-name": "Caminho 109",
    d: "M1345.254,2281.165a5.358,5.358,0,0,1-4.907-3.228l-8.567-19.834a5.343,5.343,0,0,1,2.787-7.025l5.669-2.449a5.343,5.343,0,0,1,7.025,2.787l8.567,19.834a5.344,5.344,0,0,1-2.787,7.025l-5.669,2.449A5.335,5.335,0,0,1,1345.254,2281.165Zm-12.272-23.582,8.567,19.834a4.033,4.033,0,0,0,5.3,2.1l5.669-2.448a4.034,4.034,0,0,0,2.1-5.3l-8.567-19.834a4.034,4.034,0,0,0-5.3-2.1l-5.669,2.448a4.034,4.034,0,0,0-2.1,5.3Z",
    transform: "translate(-1330.522 -2247.371)",
    fill: "#293033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_160",
    "data-name": "Grupo 160",
    transform: "translate(83.867 2.949)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M1335.728,2264.954l15.1-4.259s-3.906-12.722-8.024-11.342a78.365,78.365,0,0,0-9,3.883s-2.069,1.88-1.234,4.112S1335.728,2264.954,1335.728,2264.954Z",
    transform: "translate(-1332.372 -2249.248)",
    fill: "#293033"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_162",
    "data-name": "Grupo 162",
    transform: "translate(84.687 341.523)",
    opacity: 0.3,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M1335.56,2153.481s-5.4.477-27.011-2.143-18.023,8.384-18.023,8.384-34.765-10.218-47.865-15.2-41.193-13.714-41.193-13.714l74.245,67.14,30.512-1.477,50.132-37.539Z",
    transform: "translate(-1201.468 -2130.812)",
    fill: "#293033"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163",
    "data-name": "Grupo 163",
    transform: "translate(163.948 382.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M1394.664,2209.975l-41.18,21.924,8.122,20.174,48.858-11.584Z",
    transform: "translate(-1353.483 -2209.975)",
    fill: "#fbc7af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_237",
    "data-name": "Grupo 237",
    transform: "translate(57.785)"
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164",
    "data-name": "Grupo 164",
    transform: "translate(52.317 4.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M1294.283,1486.629c-11.961,4.473-20.292,9.256-29.338,18.883a35.957,35.957,0,0,0-9.085,30.922c1.808,9.547,6.06,16.535,5.375,26.893-.666,10.094-7.944,14.6-10.228,23.836-2.533,10.215,1.55,18.534,4.49,26.992,3.021,8.718.964,11.708-2.335,19.923-8.007,19.918,1.143,27.565,17.352,33.8,9.537,3.68,14.545,6.8,19.462,15.934,4.088,7.544,8.077,16.32,18.513,13.967,8.848-1.995,11.962-11.456,21.519-12.976,8.335-1.318,16.318,5.2,23.878,3.012,22.587-6.508,12.24-37.26,21.057-52.8,6.05-10.672,16.357-13.532,19.939-25.889,3.5-12.129.81-19.533-6.686-28.663-14.217-17.27-19.159-28.955-21.335-52-1.565-16.592-11.589-37.112-31.707-36.391C1335.155,1492.079,1317.462,1477.965,1294.283,1486.629Z",
    transform: "translate(-1250.214 -1483.816)",
    fill: "#293033"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165",
    "data-name": "Grupo 165",
    transform: "translate(0.664 119.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M1236.011,1705.665s-8.524,4.792-8.524,10.381-6.986-3.144-14.846,6.987-6.812-7.511-26.026,4.715-34.027,13.286-34.027,79.7-4.312,75.142,1.977,86.408,14.672,23.318,23.58,15.458,4.978,4.192,4.978,4.192,24.89,13.886,138.336,0V1904.6s9.17,12.314,18.34,8.908,26.2-7.6,24.366-35.37,9.432-20.96,6.288-30.13-2.882-18.34-1.048-28.558,18.078-94.058-40.61-95.106S1335.8,1704.279,1236.011,1705.665Z",
    transform: "translate(-1151.146 -1705.593)",
    fill: "#37aa9c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_166",
    "data-name": "Grupo 166",
    transform: "translate(58.98 106.309)",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_115",
    "data-name": "Caminho 115",
    d: "M1262.992,1713.587s19.071-9.707,17.5-3.622,51.441,12.2,59.955,1.893,12.206-5.065,14.639-.349,31.078.146,31.078.146-29.169-28.132-50.129-30.47-55.239-3.385-61.941,8.23Z",
    transform: "translate(-1262.992 -1679.691)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_167",
    "data-name": "Grupo 167",
    transform: "translate(173.728 173.021)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_116",
    "data-name": "Caminho 116",
    d: "M1493.425,1807.639s-3.1,39.375,4.358,51.086-6.653,30.7-6.653,30.7,27.959-3.319,27.436,11.178-14.847-9.257-25.851-6.637-10.3-5.939-8.818-8.733,12.818-5.415,8.81-28.122S1488.9,1828.385,1493.425,1807.639Z",
    transform: "translate(-1483.068 -1807.639)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_168",
    "data-name": "Grupo 168",
    transform: "translate(14.122 170.736)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_117",
    "data-name": "Caminho 117",
    d: "M1215.153,1878.417s.447-68.4-9.18-75.161c0,0,1.378,74.2-3.077,81.274s-25.939,28.738-25.939,28.738l35.371-27.167Z",
    transform: "translate(-1176.958 -1803.256)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_169",
    "data-name": "Grupo 169",
    transform: "translate(31.995 240.961)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_118",
    "data-name": "Caminho 118",
    d: "M1211.236,2017.516s39.647-9.19,42.791-24.8.175-18.052,11.877-23.292,46.636-11.782,50.653-1.7,19.179,47.772,34.3,49.626l-14.916-61.725-39.485-17.686-50.293,14.68Z",
    transform: "translate(-1211.236 -1937.942)",
    fill: "#293033"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_171",
    "data-name": "Grupo 171",
    transform: "translate(97.365 177.864)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170",
    "data-name": "Grupo 170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_119",
    "data-name": "Caminho 119",
    d: "M1361.427,1972.409c-2.729-38.7-3.261-99.494-.35-138.054.43-5.693.734-13.059-.776-16.2-.994-2.065-2.281-1.068-3.436-.33-5.039,3.224-11.241,9.657-15.571.614a1018.491,1018.491,0,0,0-3.067,154.791Z",
    transform: "translate(-1336.611 -1816.927)",
    fill: "#fff"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_172",
    "data-name": "Grupo 172",
    transform: "translate(89.232 191.544)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_27",
    "data-name": "Ret\\xE2ngulo 27",
    width: 41.047,
    height: 49.416,
    rx: 20.523,
    fill: "#293033"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_173",
    "data-name": "Grupo 173",
    transform: "translate(79.45 123.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_120",
    "data-name": "Caminho 120",
    d: "M1302.252,1727.156s.63,5.51,10.867,8.255,24.386,6.995,41.606-2.377,12.423-11.762.935-16.331S1308.54,1710.038,1302.252,1727.156Z",
    transform: "translate(-1302.252 -1713.478)",
    fill: "#20655d"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_176",
    "data-name": "Grupo 176",
    transform: "translate(90.317 107.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_174",
    "data-name": "Grupo 174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_121",
    "data-name": "Caminho 121",
    d: "M1326.729,1688.257c1.49,6.073,2.681,11.927,1.923,18.6-.532,4.665-2.837,9.18-5.557,13.75,3.474,1.253,14.517,4.8,24.89,3.259,12.46-1.846,16.716-5.636,16.716-5.636l2.029-35.679Z",
    transform: "translate(-1323.094 -1682.555)",
    fill: "#fbc7af"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_175",
    "data-name": "Grupo 175",
    transform: "translate(3.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_122",
    "data-name": "Caminho 122",
    d: "M1330.065,1688.257c1.49,6.073,2.681,11.927,1.923,18.6-.048.325-.136.637-.194.959a15.9,15.9,0,0,0,4.944,1.843c9.64,1.868,20.706.614,31.889-1.67l1.439-25.439Z",
    transform: "translate(-1330.065 -1682.555)",
    fill: "#f8ae93"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_177",
    "data-name": "Grupo 177",
    transform: "translate(73.626 28.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_123",
    "data-name": "Caminho 123",
    d: "M1368.364,1564.049c-4.657-24.3-17.964-33.7-34.167-33.69-24.721.007-44.018,21.711-43.084,46.425l.547,14.292s.806,42.373,39.025,42.373,39.356-37.3,39.553-45.39A117.033,117.033,0,0,0,1368.364,1564.049Z",
    transform: "translate(-1291.081 -1530.359)",
    fill: "#fbc7af"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_178",
    "data-name": "Grupo 178",
    transform: "translate(131.024 37.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M1401.167,1550.345s5.021,22.372,21.79,39.809l-.246-4.35s-10.077-9.942-11.814-18.312-5.207-20.385-7.075-19.88A4.6,4.6,0,0,0,1401.167,1550.345Z",
    transform: "translate(-1401.167 -1547.596)",
    fill: "#f8ae93"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_179",
    "data-name": "Grupo 179",
    transform: "translate(70.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_125",
    "data-name": "Caminho 125",
    d: "M1314.7,1477.62c-37.535,8.583-29.749,75.687-29.749,75.687s28.919-4.353,62.928-40.058c2.9-3.062,3.391,27.987,22.438,41C1370.319,1554.253,1384.046,1461.8,1314.7,1477.62Z",
    transform: "translate(-1284.283 -1475.799)",
    fill: "#293033"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_196",
    "data-name": "Grupo 196",
    transform: "translate(83.466 64.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_181",
    "data-name": "Grupo 181",
    transform: "translate(9.229 18.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_180",
    "data-name": "Grupo 180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_126",
    "data-name": "Caminho 126",
    d: "M1332.414,1637.141l.011.016a.255.255,0,0,1-.074.353,3.454,3.454,0,0,1-3.362.268,2.723,2.723,0,0,1-1.282-2.9.255.255,0,0,1,.5.124,2.167,2.167,0,0,0,1.05,2.335,3,3,0,0,0,2.82-.257A.255.255,0,0,1,1332.414,1637.141Z",
    transform: "translate(-1327.654 -1634.688)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_183",
    "data-name": "Grupo 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_182",
    "data-name": "Grupo 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_127",
    "data-name": "Caminho 127",
    d: "M1310.838,1611.808c-.026,0-.051-.008-.077-.013a1.019,1.019,0,0,1-.786-1.206c.073-.347,1.873-8.521,8.737-10.246a10.874,10.874,0,0,1,11.8,4.557,1.019,1.019,0,0,1-1.747,1.05,8.654,8.654,0,0,0-9.558-3.63c-5.619,1.411-7.223,8.618-7.237,8.691A1.02,1.02,0,0,1,1310.838,1611.808Z",
    transform: "translate(-1309.953 -1599.974)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_185",
    "data-name": "Grupo 185",
    transform: "translate(39.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_184",
    "data-name": "Grupo 184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_128",
    "data-name": "Caminho 128",
    d: "M1405.851,1611.808c.026,0,.051-.008.077-.013a1.019,1.019,0,0,0,.787-1.206c-.073-.347-1.873-8.521-8.737-10.246a10.874,10.874,0,0,0-11.8,4.557,1.019,1.019,0,0,0,1.747,1.05,8.654,8.654,0,0,1,9.558-3.63c5.619,1.411,7.223,8.618,7.237,8.691A1.02,1.02,0,0,0,1405.851,1611.808Z",
    transform: "translate(-1386.031 -1599.974)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_187",
    "data-name": "Grupo 187",
    transform: "translate(47.613 18.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_186",
    "data-name": "Grupo 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_129",
    "data-name": "Caminho 129",
    d: "M1401.323,1637.141l-.011.016a.255.255,0,0,0,.074.353,3.453,3.453,0,0,0,3.362.268,2.723,2.723,0,0,0,1.282-2.9.255.255,0,0,0-.5.124,2.167,2.167,0,0,1-1.05,2.335,3,3,0,0,1-2.821-.257A.255.255,0,0,0,1401.323,1637.141Z",
    transform: "translate(-1401.271 -1634.688)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_189",
    "data-name": "Grupo 189",
    transform: "translate(17.562 41.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_188",
    "data-name": "Grupo 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_130",
    "data-name": "Caminho 130",
    d: "M1344.439,1682.2c-.028.012-.056.025-.083.039a1.042,1.042,0,0,0-.632,1.346,12.386,12.386,0,0,0,11.931,6.1,15.135,15.135,0,0,0,12.292-8.14.791.791,0,0,0-.679-1.121,1.462,1.462,0,0,0-1.5.791,12.057,12.057,0,0,1-9.969,6.539c-6.6.687-9.894-5.173-9.925-5.232A1.12,1.12,0,0,0,1344.439,1682.2Z",
    transform: "translate(-1343.637 -1680.41)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_191",
    "data-name": "Grupo 191",
    transform: "translate(10.421 18.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_190",
    "data-name": "Grupo 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M1329.958,1639.629c-.2,2.4,1.259,4.525,3.249,4.745s3.762-1.548,3.956-3.95-1.259-4.526-3.25-4.747S1330.153,1637.228,1329.958,1639.629Z",
    transform: "translate(-1329.94 -1635.66)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_193",
    "data-name": "Grupo 193",
    transform: "translate(42.778 18.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_192",
    "data-name": "Grupo 192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    d: "M1392.016,1639.629c-.2,2.4,1.26,4.525,3.25,4.745s3.761-1.548,3.956-3.95-1.259-4.526-3.25-4.747S1392.211,1637.228,1392.016,1639.629Z",
    transform: "translate(-1391.998 -1635.66)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_195",
    "data-name": "Grupo 195",
    transform: "translate(23.912 19.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_194",
    "data-name": "Grupo 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_133",
    "data-name": "Caminho 133",
    d: "M1357.212,1651.852a6.364,6.364,0,0,0,3.744.1,6.1,6.1,0,0,0,1.8-.811c.094-.067.311-.213.363-.343-.046.113-.029-.006-.027-.065a5.018,5.018,0,0,0-.259-1.227,62.776,62.776,0,0,0-2.953-9.424,1.6,1.6,0,0,1,.392-1.856.987.987,0,0,1,1.536.323c.767,1.9,1.465,3.84,2.066,5.833q.427,1.417.793,2.863a17.668,17.668,0,0,1,.655,3.111c.153,2.33-1.947,3.5-3.551,4.03a8.2,8.2,0,0,1-5.112.1,1.273,1.273,0,0,1-.808-1.54C1355.989,1652.273,1356.637,1651.668,1357.212,1651.852Z",
    transform: "translate(-1355.814 -1637.989)",
    fill: "#293033"
  }))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_197",
    "data-name": "Grupo 197",
    transform: "translate(36.9 211.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M1221.886,1931.958l25.676-29.606s10.218-15.2,14.934-15.982a104.686,104.686,0,0,1,10.48-1.048v3.93s22.183-8.908,25.152-8.209,37.379,2.62,41.047,9.781,2.62,12.576,5.24,14.148,27.772,39.125,27.772,39.125-2.795,29.169-21.31,29.169-18.689-43.666-18.689-43.666-23.58-5.59-26.026-8.559-4.112-5.415-4.112-5.415-22.263,15.37-25.581,15.894-18.69,1.048-18.69,1.048l-14.322,30.3s-2.795,4.811-7.336,1.841S1216.21,1950.56,1221.886,1931.958Z",
    transform: "translate(-1220.645 -1881.004)",
    fill: "#fbc7af"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_198",
    "data-name": "Grupo 198",
    transform: "translate(85.887 209.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M1320.566,1884.78s-6.463,2.309-5.939,5.714,27.55-8.384,27.55-8.384l2.667,5.415s-4.274.175-4.626,2.969,4.189,6.376,4.189,6.376-26.812,13.013-25.414,15.021,23.309-4.852,23.309-4.852,5.6-6.85,7.956-6.588,15.2,4.1,15.021,3.753-19.126-8.295-18.951-11.57,10.218-4.322,10.218-4.322-10.655-6.114-11.091-9.171S1320.566,1884.78,1320.566,1884.78Z",
    transform: "translate(-1314.597 -1878.49)",
    fill: "#f8ae93"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_199",
    "data-name": "Grupo 199",
    transform: "translate(45.432 236.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M1237.007,1982.575s15.412-32.825,22.317-34.521,26.425.611,31.947-2.533,15.212-15.376,15.212-15.376l9.563,13.149,27.383,7.36s10.85,43.79,26.253,41.729c0,0-6.551,6.464-14.262,3.6s-15.406-19.109-15.4-42.863c0,0-23.52-6.376-26.026-8.559l-4.694-6.213-.53,1.556L1284.3,1955.04l-18.689,1.048-14.322,30.3S1248.922,1995,1237.007,1982.575Z",
    transform: "translate(-1237.007 -1930.145)",
    fill: "#f8ae93"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_200",
    "data-name": "Grupo 200",
    transform: "translate(88.05 211.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M1319.362,1903.745l-.617-1.156c12.257-6.548,25.62-14.406,26.245-16.071.937-2.5-.482-5.387-.5-5.415l1.172-.586c.069.139,1.687,3.435.552,6.462-.2.538-.738,1.966-13.954,9.594C1325.822,1900.291,1319.426,1903.711,1319.362,1903.745Z",
    transform: "translate(-1318.745 -1880.517)",
    fill: "#293033"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_201",
    "data-name": "Grupo 201",
    transform: "translate(114.7 216.63)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_28",
    "data-name": "Ret\\xE2ngulo 28",
    width: 1.31,
    height: 25.698,
    transform: "translate(0 1.242) rotate(-71.473)",
    fill: "#293033"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_202",
    "data-name": "Grupo 202",
    transform: "translate(112 219.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_138",
    "data-name": "Caminho 138",
    d: "M1386.874,1912.13c-.056-.021-5.687-2.167-11.164-4.724-10.19-4.756-11.233-6.827-11-8.1.732-4.063,9.859-3.222,10.9-3.112l-.136,1.3c-2.318-.243-9.033-.39-9.472,2.041-.032.178-.017,1.88,10.269,6.681,5.434,2.537,11.02,4.665,11.075,4.686Z",
    transform: "translate(-1364.679 -1896.049)",
    fill: "#293033"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_203",
    "data-name": "Grupo 203",
    transform: "translate(92.748 227.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M1328.321,1928.547l-.564-1.182c4.718-2.25,17.3-8.363,18.868-9.614,1.95-1.56,7.391-5.653,7.446-5.694l.787,1.047c-.055.041-5.479,4.122-7.414,5.67C1345.442,1920.374,1329.019,1928.214,1328.321,1928.547Z",
    transform: "translate(-1327.757 -1912.057)",
    fill: "#293033"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_204",
    "data-name": "Grupo 204",
    transform: "translate(114.64 237.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M1422.162,1997.88c-4.64-.521-8.541-3.228-11.6-8.044-2.4-3.779-4.283-8.867-5.6-15.124a108.272,108.272,0,0,1-2.075-20.63c-22.084-5.154-25.68-8.47-25.824-8.609l-.065-.073-4.112-5.415c-.369-.471-3.636-4.74-3.082-7.338a2.264,2.264,0,0,1,1.188-1.576l.613,1.157a.957.957,0,0,0-.52.691c-.322,1.512,1.57,4.645,2.839,6.266l4.078,5.369c.354.285,4.722,3.512,25.691,8.37l.516.12-.009.53c-.007.409-.51,40.912,18.108,43Z",
    transform: "translate(-1369.742 -1931.072)",
    fill: "#293033"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_205",
    "data-name": "Grupo 205",
    transform: "translate(63.312 214.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M1272.312,1906.092l-1.01-.833c2.152-2.61,13.006-15.655,15.286-16.2,2.214-.531,10.251-1.043,10.592-1.065l.7-.044v4.628h-1.31v-3.23c-2.035.139-7.933.567-9.672.985C1285.644,1890.646,1278.5,1898.592,1272.312,1906.092Z",
    transform: "translate(-1271.301 -1887.948)",
    fill: "#293033"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_206",
    "data-name": "Grupo 206",
    transform: "translate(160.148 234.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M1484.755,1966.07c-6.543-11.019-27.521-38.786-27.732-39.065l1.045-.79c.212.28,21.234,28.1,27.813,39.186Z",
    transform: "translate(-1457.023 -1926.215)",
    fill: "#293033"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_208",
    "data-name": "Grupo 208",
    transform: "translate(113.688 196.094)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_207",
    "data-name": "Grupo 207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_143",
    "data-name": "Caminho 143",
    d: "M1367.917,1852.1c.812-.04,1.625-.061,2.437-.089s1.625-.042,2.437-.062l2.437-.037,2.437-.021h.027l.021.006a5.387,5.387,0,0,1,1.641.761,4.093,4.093,0,0,1,1.244,1.322,3.716,3.716,0,0,1,.5,1.747c.026.309.007.588.008.88l-.009.869c-.017,1.158-.036,2.316-.066,3.474s-.066,2.316-.119,3.474c-.054-1.158-.086-2.316-.119-3.474s-.049-2.316-.066-3.474l-.009-.869c-.007-.286,0-.588-.025-.856a3.407,3.407,0,0,0-.458-1.557,3.792,3.792,0,0,0-1.124-1.183,5.006,5.006,0,0,0-1.49-.706l.047.006-2.437-.021-2.437-.038c-.812-.019-1.625-.032-2.437-.062S1368.729,1852.141,1367.917,1852.1Z",
    transform: "translate(-1367.917 -1851.892)",
    fill: "#fff"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_213",
    "data-name": "Grupo 213",
    transform: "translate(94.996 198.693)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_209",
    "data-name": "Grupo 209"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    cx: 1.228,
    cy: 1.228,
    r: 1.228,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_210",
    "data-name": "Grupo 210",
    transform: "translate(3.471)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    cx: 1.228,
    cy: 1.228,
    r: 1.228,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_211",
    "data-name": "Grupo 211",
    transform: "translate(3.471 3.668)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 1.228,
    cy: 1.228,
    r: 1.228,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_212",
    "data-name": "Grupo 212",
    transform: "translate(0 3.668)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9",
    "data-name": "Elipse 9",
    cx: 1.228,
    cy: 1.228,
    r: 1.228,
    fill: "#fff"
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_214",
    "data-name": "Grupo 214",
    transform: "translate(175.178 152.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_144",
    "data-name": "Caminho 144",
    d: "M1486.913,1872.179l-1.064-.764a53.043,53.043,0,0,0,5.783-11.321c2.25-6.093,4.238-15.189.931-23.921-2.951-7.792-3.013-22.257-.164-38.7,2.2-12.7,6.284-26.409,10.448-28.414l.569,1.18c-3.14,1.512-7.231,13.06-9.726,27.458-2.81,16.217-2.773,30.425.1,38.007,3.455,9.123,1.4,18.561-.939,24.873A53.327,53.327,0,0,1,1486.913,1872.179Z",
    transform: "translate(-1485.849 -1769.063)",
    fill: "#293033"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_215",
    "data-name": "Grupo 215",
    transform: "translate(38.438 156.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_145",
    "data-name": "Caminho 145",
    d: "M1230.39,1874.5l-1.309-.062c.01-.216,1.019-21.908.826-44.661-.254-29.975-2.438-48.133-6.314-52.512l.981-.869C1234.378,1787.473,1230.557,1870.953,1230.39,1874.5Z",
    transform: "translate(-1223.593 -1776.397)",
    fill: "#293033"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_216",
    "data-name": "Grupo 216",
    transform: "translate(11.804 245.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_146",
    "data-name": "Caminho 146",
    d: "M1216.2,1997.409c-1.807,0-4.079-1.128-7.146-3.547-7.734-6.1-9.92-12.574-11.515-17.3-1.29-3.822-.439-8.91.191-11.625l-24.416,18.826-.8-1.038,27.576-21.262-.612,1.976c-.024.077-2.368,7.759-.7,12.7,1.543,4.571,3.657,10.832,11.086,16.691,6.027,4.755,7.469,3.364,9.293,1.6.234-.226.475-.458.731-.686l14.433-30.531.393-.019c.158-.008,15.917-.772,18.656-1.045,1.909-.191,16.517-9.783,25.276-15.783l.74,1.081c-2.347,1.608-23.015,15.719-25.886,16.006-2.56.256-15.811.908-18.33,1.031l-14.213,30.066-.1.09c-.27.234-.532.487-.785.732-1.027.991-2.089,2.016-3.834,2.03Z",
    transform: "translate(-1172.512 -1946.372)",
    fill: "#293033"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_217",
    "data-name": "Grupo 217",
    transform: "translate(0 243.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_147",
    "data-name": "Caminho 147",
    d: "M1171.615,2026c-2.661,0-5.3-1.3-7.852-3.867-9.451-9.509-14.122-19.987-13.881-31.143.275-12.795,1.269-48.119,1.279-48.475l1.31.037c-.01.355-1,35.675-1.278,48.465-.233,10.787,4.31,20.945,13.5,30.191,2.369,2.384,4.776,3.556,7.145,3.477a7.867,7.867,0,0,0,5.2-2.411l.068-.079.09-.053c.259-.154,25.989-15.507,33.724-21.695,7.378-5.9,2.694-17.48,2.646-17.6l1.21-.5a24.711,24.711,0,0,1,1.575,7.026c.372,5.2-1.223,9.384-4.613,12.1-7.583,6.067-32.162,20.776-33.789,21.748a9.133,9.133,0,0,1-6.074,2.776C1171.792,2026,1171.7,2026,1171.615,2026Z",
    transform: "translate(-1149.873 -1942.515)",
    fill: "#293033"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_218",
    "data-name": "Grupo 218",
    transform: "translate(159.432 276.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_148",
    "data-name": "Caminho 148",
    d: "M1482.119,2059.028c-8.011,0-15.109-9.365-15.45-9.823l-.034-.049-10.985-17.926,1.117-.684,10.968,17.9c.445.583,9.285,11.945,17.557,8.669l.254-.1c9.07-3.592,21.493-8.511,23.026-21.952a116.045,116.045,0,0,0,.6-16.51c-.089-4.544-.159-8.134.778-11.63l1.266.34c-.889,3.316-.821,6.824-.734,11.265a117.1,117.1,0,0,1-.6,16.684c-1.623,14.221-15,19.518-23.845,23.022l-.254.1A9.84,9.84,0,0,1,1482.119,2059.028Z",
    transform: "translate(-1455.651 -2006.92)",
    fill: "#293033"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_219",
    "data-name": "Grupo 219",
    transform: "translate(176.769 255.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M1518.867,1975.04c-6.735-12.109-29.427-6.744-29.655-6.688l-.31-1.273a53.843,53.843,0,0,1,12.716-1.272c9.029.223,15.39,3.2,18.393,8.6Z",
    transform: "translate(-1488.902 -1965.793)",
    fill: "#293033"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_220",
    "data-name": "Grupo 220",
    transform: "translate(32.404 318.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M1269.778,2103.257c-10.552,0-19.242-.421-26.175-.993-21.837-1.8-31.194-5.327-31.582-5.476l.47-1.223c.094.036,9.637,3.625,31.329,5.4,19.95,1.635,54.532,2.026,106.117-5.36v-8.34h1.31v9.476l-.562.081C1316.565,2101.735,1289.818,2103.257,1269.778,2103.257Z",
    transform: "translate(-1212.022 -2087.268)",
    fill: "#293033"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_221",
    "data-name": "Grupo 221",
    transform: "translate(74.05 136.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M1326.814,1759.991c-15.318,0-25.842-3.124-31.28-9.284-4.162-4.715-3.629-9.42-3.6-9.617l1.3.161a12.011,12.011,0,0,0,3.317,8.624c3.568,4.017,11.716,8.807,30.268,8.807,18.621,0,27.861-5.767,32.334-10.605a19.387,19.387,0,0,0,5.265-10.423l1.306.105c-.019.23-.514,5.7-5.608,11.208C1355.459,1754,1345.908,1759.991,1326.814,1759.991Z",
    transform: "translate(-1291.895 -1737.653)",
    fill: "#293033"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_222",
    "data-name": "Grupo 222",
    transform: "translate(65.239 149.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_29",
    "data-name": "Ret\\xE2ngulo 29",
    width: 9.166,
    height: 1.31,
    transform: "translate(0 8.974) rotate(-78.247)",
    fill: "#293033"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_223",
    "data-name": "Grupo 223",
    transform: "translate(72.051 152.545)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_30",
    "data-name": "Ret\\xE2ngulo 30",
    width: 9.166,
    height: 1.31,
    transform: "translate(0 8.974) rotate(-78.247)",
    fill: "#293033"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_224",
    "data-name": "Grupo 224",
    transform: "translate(79.977 155.383)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_31",
    "data-name": "Ret\\xE2ngulo 31",
    width: 9.166,
    height: 1.31,
    transform: "translate(0 8.974) rotate(-78.247)",
    fill: "#293033"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_225",
    "data-name": "Grupo 225",
    transform: "translate(88.35 159.032)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_32",
    "data-name": "Ret\\xE2ngulo 32",
    width: 9.166,
    height: 1.31,
    transform: "translate(0 8.974) rotate(-78.247)",
    fill: "#293033"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_226",
    "data-name": "Grupo 226",
    transform: "translate(94.649 160.495)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_33",
    "data-name": "Ret\\xE2ngulo 33",
    width: 9.166,
    height: 1.31,
    transform: "translate(0 8.974) rotate(-78.247)",
    fill: "#293033"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_227",
    "data-name": "Grupo 227",
    transform: "translate(105.291 162.238)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_34",
    "data-name": "Ret\\xE2ngulo 34",
    width: 1.31,
    height: 9.166,
    transform: "matrix(0.991, -0.134, 0.134, 0.991, 0, 0.176)",
    fill: "#293033"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_228",
    "data-name": "Grupo 228",
    transform: "translate(110.871 162.238)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_35",
    "data-name": "Ret\\xE2ngulo 35",
    width: 1.31,
    height: 9.166,
    transform: "matrix(0.991, -0.134, 0.134, 0.991, 0, 0.176)",
    fill: "#293033"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_229",
    "data-name": "Grupo 229",
    transform: "translate(117.657 161.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_36",
    "data-name": "Ret\\xE2ngulo 36",
    width: 1.31,
    height: 9.166,
    transform: "matrix(0.991, -0.134, 0.134, 0.991, 0, 0.176)",
    fill: "#293033"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_230",
    "data-name": "Grupo 230",
    transform: "translate(127.137 159.861)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_37",
    "data-name": "Ret\\xE2ngulo 37",
    width: 1.31,
    height: 9.166,
    transform: "translate(0 0.176) rotate(-7.707)",
    fill: "#293033"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_231",
    "data-name": "Grupo 231",
    transform: "translate(133.726 157.962)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_38",
    "data-name": "Ret\\xE2ngulo 38",
    width: 1.31,
    height: 9.166,
    transform: "translate(0 0.608) rotate(-27.666)",
    fill: "#293033"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_232",
    "data-name": "Grupo 232",
    transform: "translate(138.694 153.851)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_39",
    "data-name": "Ret\\xE2ngulo 39",
    width: 1.31,
    height: 9.166,
    transform: "translate(0 0.608) rotate(-27.666)",
    fill: "#293033"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_233",
    "data-name": "Grupo 233",
    transform: "translate(146.237 148.316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_40",
    "data-name": "Ret\\xE2ngulo 40",
    width: 1.31,
    height: 9.166,
    transform: "translate(0 0.608) rotate(-27.667)",
    fill: "#293033"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_235",
    "data-name": "Grupo 235",
    transform: "translate(52.552 194.894)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_234",
    "data-name": "Grupo 234"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_10",
    "data-name": "Elipse 10",
    cx: 6.352,
    cy: 6.352,
    r: 6.352,
    fill: "#fff"
  })))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_236",
    "data-name": "Grupo 236",
    transform: "translate(113.037 235.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M1389.021,1938.571c-.05-.007-5.024-.662-8.4-1.181-3.492-.537-12.893-8.623-13.954-9.543l.859-.99c2.8,2.432,10.654,8.832,13.294,9.238,3.36.517,8.321,1.171,8.37,1.177Z",
    transform: "translate(-1366.669 -1926.857)",
    fill: "#293033"
  })))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_238",
    "data-name": "Grupo 238",
    transform: "translate(0.447 322.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M1163.121,2205.262s-110.2-32.488-117.536-51.875-13.283-48.556,20.514-58.381,122.217,62.877,122.217,62.877Z",
    transform: "translate(-1039.902 -2094.093)",
    fill: "#243f80"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_239",
    "data-name": "Grupo 239",
    transform: "translate(121.339 383.558)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_41",
    "data-name": "Ret\\xE2ngulo 41",
    width: 59.762,
    height: 15.554,
    rx: 7.777,
    transform: "translate(0 53.07) rotate(-62.626)",
    fill: "#243065"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_240",
    "data-name": "Grupo 240",
    transform: "translate(141.544 400.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    "data-name": "Caminho 154",
    d: "M1326.314,2244.2l41.181,21.924-8.122,20.174-48.858-11.584Z",
    transform: "translate(-1310.515 -2244.196)",
    fill: "#fbc7af"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_247",
    "data-name": "Grupo 247",
    transform: "translate(186.251 406.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_241",
    "data-name": "Grupo 241",
    transform: "translate(0 0.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    "data-name": "Caminho 155",
    d: "M1468.232,2260.752c-9.988,4.076-20.547,10.889-26.953,18.795,0,0-15.348-1.016-36.3-10.677l-8.714,24.143c22.159,7.627,32.576,15.037,32.664,15.1a20.873,20.873,0,0,0,1.5,3.448c4.162,7.735,30.159,5.993,43.754-9.967,11.6-13.6,20.953-35.216,19.766-39.912C1492.24,2254.885,1480.794,2255.633,1468.232,2260.752Z",
    transform: "translate(-1396.26 -2256.749)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_244",
    "data-name": "Grupo 244",
    transform: "translate(0 0.221)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_243",
    "data-name": "Grupo 243",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_242",
    "data-name": "Grupo 242",
    transform: "translate(-12.599 -11.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    "data-name": "Caminho 156",
    d: "M1478.821,2260.7s-18.106-5.29-26.341,7.256-80.384-3.751-80.384-3.751l21-16.372,54.663-.888,31.35-12.217,26.856,20.334-10.556,13.118Z",
    transform: "translate(-1372.097 -2234.724)",
    fill: "#293033"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_246",
    "data-name": "Grupo 246",
    transform: "translate(8.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_245",
    "data-name": "Grupo 245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    "data-name": "Caminho 158",
    d: "M1482.348,2301.658l-.668-.531c10.35-13.019,15.148-23.1,17.351-29.273,2.265-6.343,2.323-9.953,2.323-10.33a4.859,4.859,0,0,0-2.34-2.877c-2.365-1.463-7.326-2.582-17.539.4-9.747,2.842-17.935,8.283-23.087,12.347a73.251,73.251,0,0,0-8.95,8.234l-.161.184-.239-.045c-21.861-4.066-36.263-10.642-36.406-10.708l.358-.775c.141.065,14.351,6.552,35.968,10.6a76.438,76.438,0,0,1,8.885-8.148c5.216-4.115,13.508-9.626,23.393-12.508,10.548-3.076,15.759-1.85,18.267-.278a5.6,5.6,0,0,1,2.7,3.463l.006.06c0,.152.073,3.8-2.346,10.6C1497.64,2278.311,1492.8,2288.511,1482.348,2301.658Z",
    transform: "translate(-1412.63 -2256.324)",
    fill: "#293033"
  }))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_248",
    "data-name": "Grupo 248",
    transform: "translate(141.544 400.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_159",
    "data-name": "Caminho 159",
    d: "M1355.222,2259.585l-28.908-15.39-6.745,13.028-9.054,17.486,13.1-15.875,28.026,11.154Z",
    transform: "translate(-1310.516 -2244.196)",
    fill: "#f8ae93"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_249",
    "data-name": "Grupo 249",
    transform: "translate(176.797 413.332)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_42",
    "data-name": "Ret\\xE2ngulo 42",
    width: 30.983,
    height: 15.554,
    rx: 7.777,
    transform: "translate(0 29.079) rotate(-69.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M1390.563,2302.928a5.35,5.35,0,0,1-1.848-.332l-5.8-2.131a5.343,5.343,0,0,1-3.171-6.861l7.458-20.277a5.345,5.345,0,0,1,6.861-3.171l5.8,2.132a5.351,5.351,0,0,1,3.171,6.86h0l-7.458,20.277a5.355,5.355,0,0,1-5.012,3.5Zm1.656-31.792a4.041,4.041,0,0,0-3.784,2.644l-7.458,20.277a4.033,4.033,0,0,0,2.394,5.179l5.8,2.132a4.033,4.033,0,0,0,5.178-2.394l7.458-20.277h0a4.038,4.038,0,0,0-2.394-5.178l-5.8-2.132A4.043,4.043,0,0,0,1392.22,2271.136Z",
    transform: "translate(-1378.745 -2269.153)",
    fill: "#293033"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_250",
    "data-name": "Grupo 250",
    transform: "translate(182.673 414.594)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    "data-name": "Caminho 161",
    d: "M1404.712,2286.215,1389.4,2282.8s3.2-12.918,7.385-11.768a78.38,78.38,0,0,1,9.2,3.379s2.17,1.763,1.459,4.038S1404.712,2286.215,1404.712,2286.215Z",
    transform: "translate(-1389.397 -2270.956)",
    fill: "#293033"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_251",
    "data-name": "Grupo 251",
    transform: "translate(213.612 304.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M1473.93,2171.042s110.2-32.488,117.536-51.876,13.283-48.556-20.514-58.381-122.217,62.877-122.217,62.877Z",
    transform: "translate(-1448.736 -2059.873)",
    fill: "#243f80"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_252",
    "data-name": "Grupo 252",
    transform: "translate(199.843 365.716)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_43",
    "data-name": "Ret\\xE2ngulo 43",
    width: 15.554,
    height: 59.762,
    rx: 7.777,
    transform: "translate(0 7.151) rotate(-27.374)",
    fill: "#243065"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_253",
    "data-name": "Grupo 253",
    transform: "translate(163.948 382.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M1410.463,2240.489s-13.5-23.258-15.33-23-40.658,16.869-40.658,16.869l-.992-2.464,41.181-21.924Z",
    transform: "translate(-1353.483 -2209.975)",
    fill: "#f8ae93"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_254",
    "data-name": "Grupo 254",
    transform: "translate(156.81 394.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M1369.05,2253.985l-29.257-15.576,3.589-6.64.692.373-3.213,5.945,28.559,15.2Z",
    transform: "translate(-1339.793 -2231.769)",
    fill: "#293033"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_255",
    "data-name": "Grupo 255",
    transform: "translate(164.294 382.451)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_44",
    "data-name": "Ret\\xE2ngulo 44",
    width: 46.051,
    height: 0.786,
    transform: "translate(0 21.643) rotate(-28.033)",
    fill: "#293033"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_256",
    "data-name": "Grupo 256",
    transform: "translate(170.076 332.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M1367.6,2166.005l-2.363-37.1,4.771-14.7,2.492.809-4.616,14.22,2.331,36.6Z",
    transform: "translate(-1365.236 -2114.205)",
    fill: "#243065"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_257",
    "data-name": "Grupo 257",
    transform: "translate(82.164 332.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M1212.458,2125.2a26.374,26.374,0,0,1-3.282-.209,34.353,34.353,0,0,1-12.546-4.274l1.376-2.229-.688,1.115.687-1.115a32.25,32.25,0,0,0,11.577,3.915c8.409,1.028,15.082-2.224,19.838-9.666l2.208,1.41C1226,2122.951,1218.577,2125.2,1212.458,2125.2Z",
    transform: "translate(-1196.629 -2112.737)",
    fill: "#243065"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_258",
    "data-name": "Grupo 258",
    transform: "translate(210.91 329.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M1463.375,2126.989a15.676,15.676,0,0,1-2.891-.265c-7.134-1.335-12.831-7.655-16.932-18.785l2.458-.906c3.76,10.2,8.792,15.963,14.955,17.116,10.461,1.955,21.046-9.881,21.152-10l1.965,1.734C1483.65,2116.373,1474.147,2126.989,1463.375,2126.989Z",
    transform: "translate(-1443.553 -2107.033)",
    fill: "#243065"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_259",
    "data-name": "Grupo 259",
    transform: "translate(64.793 330.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M1222.325,2212.551l-1.165-.6,24.255-47.274c-4.517-3.66-45.275-36.316-82.1-53.631l.557-1.185c39,18.336,82.353,53.78,82.786,54.136l.408.335Z",
    transform: "translate(-1163.312 -2109.863)",
    fill: "#293033"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_260",
    "data-name": "Grupo 260",
    transform: "translate(213.192 303.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M1448.77,2123.583l-.841-1c.186-.155,18.776-15.662,42.029-31.2a317,317,0,0,1,37.4-21.875c13.981-6.75,25.754-10.4,34.991-10.844l.063,1.308c-16.28.784-41.077,12.02-71.712,32.493C1467.5,2107.96,1448.954,2123.429,1448.77,2123.583Z",
    transform: "translate(-1447.929 -2058.657)",
    fill: "#293033"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_263",
    "data-name": "Grupo 263",
    transform: "translate(201.206 304.204)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_262",
    "data-name": "Grupo 262",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_261",
    "data-name": "Grupo 261",
    transform: "translate(-4.96 -36.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M1427.525,2109.965s144.7-86.823,144.7-59.546v38.757s66.414-27.985,35.761-70.427-82.133-35.761-110.82-7.466-81.74,77.884-81.74,77.884Z",
    transform: "translate(-1415.429 -1988.488)",
    fill: "#293033"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_266",
    "data-name": "Grupo 266",
    transform: "translate(0 322.102)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_265",
    "data-name": "Grupo 265",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_264",
    "data-name": "Grupo 264",
    transform: "translate(-34.925 -36.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    "data-name": "Caminho 172",
    d: "M1160.609,2144.293s-144.7-86.823-144.7-59.546V2123.5s-66.414-27.985-35.761-70.427,82.133-35.761,110.82-7.467,81.74,77.884,81.74,77.884Z",
    transform: "translate(-972.063 -2022.816)",
    fill: "#293033"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_288",
    "data-name": "Grupo 288",
    transform: "translate(135.829 504.423)"
  }, _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_271",
    "data-name": "Grupo 271",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_269",
    "data-name": "Grupo 269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    "data-name": "Caminho 174",
    d: "M394.481,1773.3V1632.837h374.81V1773.3l-198.644.874Z",
    transform: "translate(-394.481 -1632.837)",
    fill: "#f4c085"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_270",
    "data-name": "Grupo 270",
    transform: "translate(202.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_45",
    "data-name": "Ret\\xE2ngulo 45",
    width: 172.191,
    height: 140.459,
    fill: "#f1ac6a"
  })))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_272",
    "data-name": "Grupo 272",
    transform: "translate(71.601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_46",
    "data-name": "Ret\\xE2ngulo 46",
    width: 23.374,
    height: 24.368,
    fill: "#f5f6f6"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    "data-name": "Caminho 175",
    d: "M531.805,1678.916l3.292,8.552,3.49-8.256Z",
    transform: "translate(-460.205 -1654.891)",
    fill: "#f5f6f6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M543.485,1678.213l3.292,8.552,3.49-8.256Z",
    transform: "translate(-465.794 -1654.554)",
    fill: "#f5f6f6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    "data-name": "Caminho 177",
    d: "M555.727,1678.213l3.292,8.552,3.49-8.256Z",
    transform: "translate(-471.653 -1654.554)",
    fill: "#f5f6f6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    "data-name": "Caminho 178",
    d: "M563.417,1678.213l3.292,8.552,3.49-8.256Z",
    transform: "translate(-475.334 -1654.554)",
    fill: "#f5f6f6"
  })), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_273",
    "data-name": "Grupo 273",
    transform: "translate(286.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_47",
    "data-name": "Ret\\xE2ngulo 47",
    width: 36.507,
    height: 44.487,
    fill: "#f5f6f6"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M943.9,1716.962l5.141,15.614,5.45-15.073Z",
    transform: "translate(-657.432 -1673.099)",
    fill: "#f5f6f6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    "data-name": "Caminho 180",
    d: "M962.139,1715.678l5.141,15.614,5.45-15.073Z",
    transform: "translate(-666.163 -1672.484)",
    fill: "#f5f6f6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    "data-name": "Caminho 181",
    d: "M981.259,1715.678l5.141,15.614,5.45-15.073Z",
    transform: "translate(-675.314 -1672.484)",
    fill: "#f5f6f6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_182",
    "data-name": "Caminho 182",
    d: "M993.272,1715.678l5.141,15.614,5.45-15.073Z",
    transform: "translate(-681.063 -1672.484)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_287",
    "data-name": "Grupo 287",
    transform: "translate(267.738 104.142)",
    opacity: 0.61,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_279",
    "data-name": "Grupo 279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_274",
    "data-name": "Grupo 274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_183",
    "data-name": "Caminho 183",
    d: "M934.729,1862.985l-23.449-.285a3.339,3.339,0,0,1-3.3-3.38l.285-23.448a3.339,3.339,0,0,1,3.38-3.3l23.449.285a3.339,3.339,0,0,1,3.3,3.381l-.285,23.448A3.339,3.339,0,0,1,934.729,1862.985Zm-23.092-29.6a2.519,2.519,0,0,0-2.553,2.492l-.285,23.448a2.519,2.519,0,0,0,2.491,2.553l23.449.285a2.535,2.535,0,0,0,2.553-2.492l.285-23.448a2.535,2.535,0,0,0-2.492-2.553Z",
    transform: "translate(-907.981 -1832.572)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_278",
    "data-name": "Grupo 278",
    transform: "translate(4.528 4.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_48",
    "data-name": "Ret\\xE2ngulo 48",
    width: 3.539,
    height: 21.103,
    transform: "translate(0 21.057) rotate(-89.303)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_277",
    "data-name": "Grupo 277",
    transform: "translate(3.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_275",
    "data-name": "Grupo 275"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_49",
    "data-name": "Ret\\xE2ngulo 49",
    width: 10.813,
    height: 3.539,
    transform: "translate(1.527 16.528) rotate(-89.303)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    "data-name": "Caminho 184",
    d: "M922.954,1847.266l3.5-5.892,3.354,5.976Z",
    transform: "translate(-922.954 -1841.374)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_276",
    "data-name": "Grupo 276",
    transform: "translate(8.06 0.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_50",
    "data-name": "Ret\\xE2ngulo 50",
    width: 10.813,
    height: 3.539,
    transform: "translate(1.528 16.528) rotate(-89.303)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    "data-name": "Caminho 185",
    d: "M938.412,1847.454l3.5-5.892,3.354,5.975Z",
    transform: "translate(-938.412 -1841.562)",
    fill: "#28364c"
  })))))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_281",
    "data-name": "Grupo 281",
    transform: "translate(33.806 0.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_280",
    "data-name": "Grupo 280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    "data-name": "Caminho 186",
    d: "M999.565,1863.773l-23.448-.285a3.339,3.339,0,0,1-3.3-3.38l.285-23.448a3.339,3.339,0,0,1,3.38-3.3l23.449.285a3.34,3.34,0,0,1,3.3,3.381l-.285,23.448A3.339,3.339,0,0,1,999.565,1863.773Zm-23.092-29.6a2.52,2.52,0,0,0-2.553,2.492l-.285,23.448a2.52,2.52,0,0,0,2.492,2.553l23.448.285a2.535,2.535,0,0,0,2.553-2.492l.285-23.448a2.534,2.534,0,0,0-2.492-2.553Z",
    transform: "translate(-972.818 -1833.359)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    "data-name": "Caminho 187",
    d: "M996.906,1846.067l-1.348,1.9.97-.012-2.182,3.374.759-2.824-.967-.011,1.419-2.443-4.284-.052-.094,7.775c-.026,2.13,2.1,3.912,4.87,4.208l-.053,4.377-2.135-.026c-.892-.011-1.62.42-1.627.961l8.944.108c.007-.541-.712-.989-1.6-1l-2.135-.026.053-4.377c2.778-.229,4.945-1.959,4.971-4.089l.094-7.775Z",
    transform: "translate(-981.605 -1839.408)",
    fill: "#343434"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_286",
    "data-name": "Grupo 286",
    transform: "translate(67.612 0.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_282",
    "data-name": "Grupo 282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    "data-name": "Caminho 188",
    d: "M1064.4,1864.562l-23.448-.285a3.34,3.34,0,0,1-3.3-3.38l.285-23.448a3.339,3.339,0,0,1,3.38-3.3l23.449.285a3.339,3.339,0,0,1,3.3,3.381l-.285,23.448A3.339,3.339,0,0,1,1064.4,1864.562Zm-23.092-29.6a2.518,2.518,0,0,0-2.553,2.492l-.285,23.448a2.52,2.52,0,0,0,2.492,2.553l23.448.285a2.535,2.535,0,0,0,2.553-2.492l.285-23.448a2.534,2.534,0,0,0-2.492-2.553Z",
    transform: "translate(-1037.654 -1834.149)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_285",
    "data-name": "Grupo 285",
    transform: "translate(6.237 7.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_189",
    "data-name": "Caminho 189",
    d: "M1066.642,1848.617a.231.231,0,0,0-.236.222l-.009.724.467.006.009-.724A.231.231,0,0,0,1066.642,1848.617Z",
    transform: "translate(-1057.647 -1848.617)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_284",
    "data-name": "Grupo 284",
    transform: "translate(0 0.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_190",
    "data-name": "Caminho 190",
    d: "M1053.972,1857.562h.164a3.648,3.648,0,0,1,4.3.052h.072a3.617,3.617,0,0,1,4.291.052h.073l.09,0a3.591,3.591,0,0,1,4.282.052l.156,0a8.929,8.929,0,0,0-17.781-.216h.073A3.593,3.593,0,0,1,1053.972,1857.562Z",
    transform: "translate(-1049.616 -1849.459)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    "data-name": "Caminho 191",
    d: "M1057.909,1857.474c0-.066-.471-6.425,4.644-8.061l.032.109c-5.015,1.613-4.559,7.879-4.542,7.937Z",
    transform: "translate(-1053.58 -1849.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_192",
    "data-name": "Caminho 192",
    d: "M1071.143,1857.64l-.133-.019c.017-.057.626-6.311-4.348-8.036l.034-.109C1071.771,1851.236,1071.161,1857.582,1071.143,1857.64Z",
    transform: "translate(-1057.774 -1849.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_283",
    "data-name": "Grupo 283",
    transform: "translate(8.452 6.648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_51",
    "data-name": "Ret\\xE2ngulo 51",
    width: 10.131,
    height: 0.5,
    transform: "translate(0.001 10.13) rotate(-89.303)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_193",
    "data-name": "Caminho 193",
    d: "M1068.158,1881.62",
    transform: "translate(-1066.942 -1871.475)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_194",
    "data-name": "Caminho 194",
    d: "M1068.034,1880.04l-.006.5v.017l0,.366a.841.841,0,0,1-.843.848.858.858,0,0,1-.855-.868l0-.367v-.016l.006-.5-.5-.006-.01.882a1.348,1.348,0,1,0,2.7.033l.011-.882Z",
    transform: "translate(-1065.826 -1870.706)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_195",
    "data-name": "Caminho 195",
    d: "M1066.513,1857.654l-.133,0,.115-8.065h.116Z",
    transform: "translate(-1057.639 -1849.496)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_308",
    "data-name": "Grupo 308",
    transform: "translate(138.25 459.092)"
  }, _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_291",
    "data-name": "Grupo 291",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_289",
    "data-name": "Grupo 289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_196",
    "data-name": "Caminho 196",
    d: "M399.124,1592.317V1545.9H523v46.421l-65.651.289Z",
    transform: "translate(-399.124 -1545.896)",
    fill: "#f4c085"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_290",
    "data-name": "Grupo 290",
    transform: "translate(66.965)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_52",
    "data-name": "Ret\\xE2ngulo 52",
    width: 56.908,
    height: 46.421,
    fill: "#f1ac6a"
  })))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_292",
    "data-name": "Grupo 292",
    transform: "translate(23.664 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_53",
    "data-name": "Ret\\xE2ngulo 53",
    width: 7.725,
    height: 8.053,
    fill: "#f5f6f6"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_197",
    "data-name": "Caminho 197",
    d: "M444.51,1561.125l1.088,2.827,1.153-2.729Z",
    transform: "translate(-420.846 -1553.185)",
    fill: "#f5f6f6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_198",
    "data-name": "Caminho 198",
    d: "M448.37,1560.892l1.088,2.827,1.153-2.729Z",
    transform: "translate(-422.693 -1553.073)",
    fill: "#f5f6f6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_199",
    "data-name": "Caminho 199",
    d: "M452.416,1560.892l1.088,2.827,1.153-2.729Z",
    transform: "translate(-424.63 -1553.073)",
    fill: "#f5f6f6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_200",
    "data-name": "Caminho 200",
    d: "M454.957,1560.892l1.088,2.827,1.153-2.729Z",
    transform: "translate(-425.846 -1553.073)",
    fill: "#f5f6f6"
  })), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_293",
    "data-name": "Grupo 293",
    transform: "translate(94.676 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_54",
    "data-name": "Ret\\xE2ngulo 54",
    width: 12.065,
    height: 14.703,
    fill: "#f5f6f6"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_201",
    "data-name": "Caminho 201",
    d: "M580.7,1573.7l1.7,5.16,1.8-4.982Z",
    transform: "translate(-486.029 -1559.202)",
    fill: "#f5f6f6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_202",
    "data-name": "Caminho 202",
    d: "M586.733,1573.274l1.7,5.16,1.8-4.982Z",
    transform: "translate(-488.914 -1558.999)",
    fill: "#f5f6f6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_203",
    "data-name": "Caminho 203",
    d: "M593.053,1573.274l1.7,5.16,1.8-4.982Z",
    transform: "translate(-491.939 -1558.999)",
    fill: "#f5f6f6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_204",
    "data-name": "Caminho 204",
    d: "M597.023,1573.274l1.7,5.16,1.8-4.982Z",
    transform: "translate(-493.839 -1558.999)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_307",
    "data-name": "Grupo 307",
    transform: "translate(88.487 34.419)",
    opacity: 0.61,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_299",
    "data-name": "Grupo 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_294",
    "data-name": "Grupo 294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_205",
    "data-name": "Caminho 205",
    d: "M577.675,1621.959l-7.75-.094a1.1,1.1,0,0,1-1.09-1.117l.094-7.75a1.1,1.1,0,0,1,1.117-1.09l7.75.094a1.1,1.1,0,0,1,1.09,1.117l-.094,7.749A1.1,1.1,0,0,1,577.675,1621.959Zm-7.632-9.781a.833.833,0,0,0-.844.823l-.094,7.75a.833.833,0,0,0,.823.844l7.75.094a.838.838,0,0,0,.844-.824l.094-7.75a.837.837,0,0,0-.823-.844Z",
    transform: "translate(-568.835 -1611.908)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_298",
    "data-name": "Grupo 298",
    transform: "translate(1.496 1.517)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_55",
    "data-name": "Ret\\xE2ngulo 55",
    width: 1.17,
    height: 6.974,
    transform: "translate(0 6.959) rotate(-89.303)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_297",
    "data-name": "Grupo 297",
    transform: "translate(1.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_295",
    "data-name": "Grupo 295"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_56",
    "data-name": "Ret\\xE2ngulo 56",
    width: 3.574,
    height: 1.17,
    transform: "translate(0.505 5.463) rotate(-89.303)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_206",
    "data-name": "Caminho 206",
    d: "M573.783,1616.764l1.156-1.947,1.109,1.975Z",
    transform: "translate(-573.783 -1614.817)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_296",
    "data-name": "Grupo 296",
    transform: "translate(2.664 0.032)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_57",
    "data-name": "Ret\\xE2ngulo 57",
    width: 3.574,
    height: 1.17,
    transform: "translate(0.505 5.463) rotate(-89.303)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M578.892,1616.826l1.156-1.947,1.108,1.975Z",
    transform: "translate(-578.892 -1614.879)",
    fill: "#28364c"
  })))))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_301",
    "data-name": "Grupo 301",
    transform: "translate(11.173 0.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_300",
    "data-name": "Grupo 300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M599.1,1622.219l-7.75-.094a1.1,1.1,0,0,1-1.09-1.117l.094-7.75a1.1,1.1,0,0,1,1.117-1.091l7.75.094a1.1,1.1,0,0,1,1.091,1.117l-.094,7.75A1.1,1.1,0,0,1,599.1,1622.219Zm-7.632-9.781a.833.833,0,0,0-.844.824l-.094,7.75a.832.832,0,0,0,.823.844l7.75.094a.838.838,0,0,0,.844-.823l.094-7.75a.837.837,0,0,0-.823-.844Z",
    transform: "translate(-590.263 -1612.168)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M598.224,1616.367l-.446.628.321,0-.721,1.115.251-.933-.32,0,.469-.808-1.416-.017-.031,2.569c-.008.7.693,1.293,1.61,1.391l-.018,1.446-.705-.008c-.295,0-.535.139-.538.318l2.956.036c0-.179-.235-.327-.53-.331l-.706-.008.017-1.447a1.606,1.606,0,0,0,1.643-1.352l.031-2.569Z",
    transform: "translate(-593.167 -1614.167)",
    fill: "#343434"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_306",
    "data-name": "Grupo 306",
    transform: "translate(22.345 0.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_302",
    "data-name": "Grupo 302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M620.531,1622.48l-7.75-.094a1.1,1.1,0,0,1-1.09-1.117l.094-7.75a1.1,1.1,0,0,1,1.117-1.09l7.75.094a1.1,1.1,0,0,1,1.09,1.117l-.094,7.75A1.1,1.1,0,0,1,620.531,1622.48ZM612.9,1612.7a.833.833,0,0,0-.844.824l-.094,7.75a.833.833,0,0,0,.824.844l7.75.094a.838.838,0,0,0,.844-.824l.094-7.75a.837.837,0,0,0-.824-.844Z",
    transform: "translate(-611.691 -1612.429)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_305",
    "data-name": "Grupo 305",
    transform: "translate(2.061 2.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M621.271,1617.211a.076.076,0,0,0-.078.073l0,.239.154,0,0-.239A.076.076,0,0,0,621.271,1617.211Z",
    transform: "translate(-618.298 -1617.211)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_304",
    "data-name": "Grupo 304",
    transform: "translate(0 0.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M617.084,1620.167h.055a1.206,1.206,0,0,1,1.42.017h.023a1.2,1.2,0,0,1,1.418.017h.054a1.187,1.187,0,0,1,1.415.017h.052a2.951,2.951,0,0,0-5.877-.071h.025A1.187,1.187,0,0,1,617.084,1620.167Z",
    transform: "translate(-615.644 -1617.489)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M618.385,1620.138c0-.022-.155-2.123,1.535-2.664l.01.036c-1.657.533-1.506,2.6-1.5,2.623Z",
    transform: "translate(-616.954 -1617.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M622.759,1620.192l-.044-.006c.006-.019.207-2.086-1.437-2.656l.011-.036C622.966,1618.076,622.765,1620.173,622.759,1620.192Z",
    transform: "translate(-618.34 -1617.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_303",
    "data-name": "Grupo 303",
    transform: "translate(2.794 2.197)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_58",
    "data-name": "Ret\\xE2ngulo 58",
    width: 3.348,
    height: 0.165,
    transform: "translate(0 3.348) rotate(-89.303)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M621.772,1628.118",
    transform: "translate(-621.37 -1624.765)",
    fill: "#28364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M621.732,1627.6l0,.165v.006l0,.121a.278.278,0,0,1-.279.28.284.284,0,0,1-.283-.287l0-.121v-.006l0-.165-.165,0,0,.292a.446.446,0,0,0,.891.011l0-.292Z",
    transform: "translate(-621.002 -1624.511)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M621.229,1620.2h-.044l.038-2.666h.039Z",
    transform: "translate(-618.296 -1617.501)",
    fill: "#fff"
  })))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Linha_11",
    "data-name": "Linha 11",
    x2: 123.874,
    transform: "translate(0 46.421)",
    fill: "none",
    stroke: "#28364c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_317",
    "data-name": "Grupo 317",
    transform: "translate(803.728 201.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_309",
    "data-name": "Grupo 309",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_59",
    "data-name": "Ret\\xE2ngulo 59",
    width: 55.528,
    height: 82.382,
    transform: "translate(0 55.515) rotate(-88.752)",
    fill: "#ffc70f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_312",
    "data-name": "Grupo 312",
    transform: "translate(1.457 0.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_311",
    "data-name": "Grupo 311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_310",
    "data-name": "Grupo 310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M1760.613,1055.635a5.711,5.711,0,0,1-.783.722l-2.337,1.959-8.689,7.1-28.911,23.277-.238.192-.235-.2-.569-.475-28.809-24.19-8.675-7.4-2.334-2.04a5.826,5.826,0,0,1-.781-.751,5.893,5.893,0,0,1,.878.635l2.424,1.932,8.828,7.214,28.95,24.022.569.474-.473,0,29.05-23.1,8.837-6.92,2.424-1.851A5.679,5.679,0,0,1,1760.613,1055.635Z",
    transform: "translate(-1678.25 -1053.84)",
    fill: "#28364c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_314",
    "data-name": "Grupo 314",
    transform: "translate(0.246 23.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_313",
    "data-name": "Grupo 313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M1675.929,1130.12c-.155-.137,6.2-7.612,14.2-16.694s14.61-16.337,14.764-16.2-6.2,7.61-14.2,16.695S1676.084,1130.256,1675.929,1130.12Z",
    transform: "translate(-1675.927 -1097.223)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_316",
    "data-name": "Grupo 316",
    transform: "translate(56.605 23.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_315",
    "data-name": "Grupo 315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    "data-name": "Caminho 220",
    d: "M1784.022,1097.038c.165-.124,6.121,7.564,13.3,17.168s12.868,17.495,12.7,17.618-6.12-7.562-13.3-17.17S1783.856,1097.161,1784.022,1097.038Z",
    transform: "translate(-1784.018 -1097.036)",
    fill: "#28364c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_375",
    "data-name": "Grupo 375",
    transform: "translate(758.844 791.099)"
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_253",
    "data-name": "Caminho 253",
    d: "M1642.74,2204.777c2.554-4.467,1.491-11.485,8.3-16.8s10.634-5.317,10.634-5.317a24.026,24.026,0,0,1,5.53,6.168,21.237,21.237,0,0,0-12.23,4.892c-5.21,4.68-8.085,11.918-8.085,11.918h-3.293Z",
    transform: "translate(-1614.913 -2182.657)",
    fill: "#5a4218"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_254",
    "data-name": "Caminho 254",
    d: "M1592.527,2265.264s-4.042-6.806-2.978-22.333,12.974-18.717,21.907-19.994,17.228-1.276,28.076,10.21,5.676,38.237-9.213,42.491S1602.311,2281.429,1592.527,2265.264Z",
    transform: "translate(-1589.371 -2201.668)",
    fill: "#d73331"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_255",
    "data-name": "Caminho 255",
    d: "M1669.586,2233.423c-6.493-6.875-12.072-9.633-17.419-10.467h0a47.449,47.449,0,0,1,10.614,10.522c4.151,6.049,4.611,17.232,4.611,17.232l-4.2,24.071C1675.873,2268.184,1679.717,2244.149,1669.586,2233.423Z",
    transform: "translate(-1619.425 -2201.944)",
    fill: "#341615",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_256",
    "data-name": "Caminho 256",
    d: "M1612.678,2232.34a5.2,5.2,0,0,0-3.657.156c-3.033,1.28-9.416,4.588-10.7,10.164a53.543,53.543,0,0,0,0,20.874s.507-18.177,5.634-22.338a18.693,18.693,0,0,1,8.412-3.827,2.6,2.6,0,0,0,.452-4.978Z",
    transform: "translate(-1593.164 -2206.311)",
    fill: "#fff",
    opacity: 0.2
  })))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(172.586 58.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_257",
    "data-name": "Caminho 257",
    d: "M517.476,694.72a25.739,25.739,0,1,1,25.883-25.738A25.812,25.812,0,0,1,517.476,694.72Z",
    transform: "translate(896.057 1174.228)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_258",
    "data-name": "Caminho 258",
    d: "M506.271,658.888l-18.3,18.156",
    transform: "translate(889.406 1202.926)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_259",
    "data-name": "Caminho 259",
    d: "M346.994,2,319.765,29.079",
    transform: "translate(580.874 -2)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_260",
    "data-name": "Caminho 260",
    d: "M346.994,29.079,319.765,2",
    transform: "translate(580.874 -2)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_261",
    "data-name": "Caminho 261",
    d: "M333.239,576.763,306.01,603.842",
    transform: "translate(555.644 1052.284)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_262",
    "data-name": "Caminho 262",
    d: "M333.239,603.842,306.01,576.763",
    transform: "translate(555.644 1052.284)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_263",
    "data-name": "Caminho 263",
    d: "M40.508,187.274H2",
    transform: "translate(-2 337.847)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_264",
    "data-name": "Caminho 264",
    d: "M8.795,218.857V180.52",
    transform: "translate(10.464 325.458)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_265",
    "data-name": "Caminho 265",
    d: "M428.168,168.545a23.273,23.273,0,1,1,23.4-23.272A23.345,23.345,0,0,1,428.168,168.545Z",
    transform: "translate(736.789 218.115)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_266",
    "data-name": "Caminho 266",
    d: "M593.045,375.292a23.273,23.273,0,1,1,23.4-23.272A23.345,23.345,0,0,1,593.045,375.292Z",
    transform: "translate(1039.222 597.35)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_267",
    "data-name": "Caminho 267",
    d: "M73.893,502.029a23.273,23.273,0,1,1,23.4-23.272A23.345,23.345,0,0,1,73.893,502.029Z",
    transform: "translate(86.946 829.823)",
    fill: "none",
    stroke: "#37aa9c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_268",
    "data-name": "Caminho 268",
    d: "M157.379,28.7a8.476,8.476,0,1,0,8.477-8.429A8.453,8.453,0,0,0,157.379,28.7Z",
    transform: "translate(283.011 31.518)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_269",
    "data-name": "Caminho 269",
    d: "M157.379,49.475a8.476,8.476,0,1,0,8.477-8.429A8.453,8.453,0,0,0,157.379,49.475Z",
    transform: "translate(283.011 69.622)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_270",
    "data-name": "Caminho 270",
    d: "M157.379,70.229a8.476,8.476,0,1,0,8.477-8.429A8.453,8.453,0,0,0,157.379,70.229Z",
    transform: "translate(283.011 107.692)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_271",
    "data-name": "Caminho 271",
    d: "M157.379,91a8.476,8.476,0,1,0,8.477-8.428A8.453,8.453,0,0,0,157.379,91Z",
    transform: "translate(283.011 145.791)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_272",
    "data-name": "Caminho 272",
    d: "M157.379,111.756a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,157.379,111.756Z",
    transform: "translate(283.011 183.863)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_273",
    "data-name": "Caminho 273",
    d: "M157.379,132.524a8.476,8.476,0,1,0,8.477-8.426A8.452,8.452,0,0,0,157.379,132.524Z",
    transform: "translate(283.011 221.964)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_274",
    "data-name": "Caminho 274",
    d: "M136.506,28.7a8.476,8.476,0,1,0,8.477-8.429A8.453,8.453,0,0,0,136.506,28.7Z",
    transform: "translate(244.724 31.518)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_275",
    "data-name": "Caminho 275",
    d: "M136.506,49.475a8.476,8.476,0,1,0,8.477-8.429A8.453,8.453,0,0,0,136.506,49.475Z",
    transform: "translate(244.724 69.622)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_276",
    "data-name": "Caminho 276",
    d: "M136.506,70.229a8.476,8.476,0,1,0,8.477-8.429A8.453,8.453,0,0,0,136.506,70.229Z",
    transform: "translate(244.724 107.692)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_277",
    "data-name": "Caminho 277",
    d: "M136.506,91a8.476,8.476,0,1,0,8.477-8.428A8.453,8.453,0,0,0,136.506,91Z",
    transform: "translate(244.724 145.791)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_278",
    "data-name": "Caminho 278",
    d: "M136.506,111.756a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,136.506,111.756Z",
    transform: "translate(244.724 183.863)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_279",
    "data-name": "Caminho 279",
    d: "M136.506,132.524a8.476,8.476,0,1,0,8.477-8.426A8.452,8.452,0,0,0,136.506,132.524Z",
    transform: "translate(244.724 221.964)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_280",
    "data-name": "Caminho 280",
    d: "M115.617,28.7a8.476,8.476,0,1,0,8.475-8.429A8.452,8.452,0,0,0,115.617,28.7Z",
    transform: "translate(206.407 31.518)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_281",
    "data-name": "Caminho 281",
    d: "M115.617,49.475a8.476,8.476,0,1,0,8.475-8.429A8.452,8.452,0,0,0,115.617,49.475Z",
    transform: "translate(206.407 69.622)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_282",
    "data-name": "Caminho 282",
    d: "M115.617,70.229a8.476,8.476,0,1,0,8.475-8.429A8.452,8.452,0,0,0,115.617,70.229Z",
    transform: "translate(206.407 107.692)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_283",
    "data-name": "Caminho 283",
    d: "M115.617,91a8.476,8.476,0,1,0,8.475-8.428A8.452,8.452,0,0,0,115.617,91Z",
    transform: "translate(206.407 145.791)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_284",
    "data-name": "Caminho 284",
    d: "M115.617,111.756a8.476,8.476,0,1,0,8.475-8.429A8.452,8.452,0,0,0,115.617,111.756Z",
    transform: "translate(206.407 183.863)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_285",
    "data-name": "Caminho 285",
    d: "M115.617,132.524a8.476,8.476,0,1,0,8.475-8.426A8.452,8.452,0,0,0,115.617,132.524Z",
    transform: "translate(206.407 221.964)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_286",
    "data-name": "Caminho 286",
    d: "M94.744,28.7a8.476,8.476,0,1,0,8.476-8.429A8.452,8.452,0,0,0,94.744,28.7Z",
    transform: "translate(168.12 31.518)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_287",
    "data-name": "Caminho 287",
    d: "M94.744,49.475a8.476,8.476,0,1,0,8.476-8.429A8.452,8.452,0,0,0,94.744,49.475Z",
    transform: "translate(168.12 69.622)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_288",
    "data-name": "Caminho 288",
    d: "M94.744,70.229A8.476,8.476,0,1,0,103.22,61.8,8.452,8.452,0,0,0,94.744,70.229Z",
    transform: "translate(168.12 107.692)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_289",
    "data-name": "Caminho 289",
    d: "M94.744,91a8.476,8.476,0,1,0,8.476-8.428A8.452,8.452,0,0,0,94.744,91Z",
    transform: "translate(168.12 145.791)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_290",
    "data-name": "Caminho 290",
    d: "M94.744,111.756a8.476,8.476,0,1,0,8.476-8.429A8.452,8.452,0,0,0,94.744,111.756Z",
    transform: "translate(168.12 183.863)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_291",
    "data-name": "Caminho 291",
    d: "M94.744,132.524a8.476,8.476,0,1,0,8.476-8.426A8.452,8.452,0,0,0,94.744,132.524Z",
    transform: "translate(168.12 221.964)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_292",
    "data-name": "Caminho 292",
    d: "M487.944,523.161a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,487.944,523.161Z",
    transform: "translate(889.364 938.501)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_293",
    "data-name": "Caminho 293",
    d: "M487.945,543.916a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,487.945,543.916Z",
    transform: "translate(889.366 976.572)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_294",
    "data-name": "Caminho 294",
    d: "M487.945,564.685a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,487.945,564.685Z",
    transform: "translate(889.366 1014.668)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_295",
    "data-name": "Caminho 295",
    d: "M467.056,523.159a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,467.056,523.159Z",
    transform: "translate(851.049 938.497)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_296",
    "data-name": "Caminho 296",
    d: "M467.056,543.916a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,467.056,543.916Z",
    transform: "translate(851.049 976.572)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_297",
    "data-name": "Caminho 297",
    d: "M467.056,564.681a8.476,8.476,0,1,0,8.477-8.426A8.452,8.452,0,0,0,467.056,564.681Z",
    transform: "translate(851.049 1014.666)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_298",
    "data-name": "Caminho 298",
    d: "M571.653,107.428A8.476,8.476,0,1,0,580.13,99,8.452,8.452,0,0,0,571.653,107.428Z",
    transform: "translate(1042.911 175.928)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_299",
    "data-name": "Caminho 299",
    d: "M571.654,128.183a8.476,8.476,0,1,0,8.475-8.429A8.453,8.453,0,0,0,571.654,128.183Z",
    transform: "translate(1042.913 213.995)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_300",
    "data-name": "Caminho 300",
    d: "M571.654,148.953a8.476,8.476,0,1,0,8.475-8.426A8.452,8.452,0,0,0,571.654,148.953Z",
    transform: "translate(1042.913 252.099)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_301",
    "data-name": "Caminho 301",
    d: "M550.765,107.429A8.476,8.476,0,1,0,559.239,99,8.453,8.453,0,0,0,550.765,107.429Z",
    transform: "translate(1004.596 175.927)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_302",
    "data-name": "Caminho 302",
    d: "M550.765,128.185a8.476,8.476,0,1,0,8.474-8.429A8.453,8.453,0,0,0,550.765,128.185Z",
    transform: "translate(1004.596 213.999)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_303",
    "data-name": "Caminho 303",
    d: "M550.765,148.955a8.476,8.476,0,1,0,8.474-8.429A8.452,8.452,0,0,0,550.765,148.955Z",
    transform: "translate(1004.596 252.097)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_304",
    "data-name": "Caminho 304",
    d: "M164.866,668.438a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,164.866,668.438Z",
    transform: "translate(296.744 1204.982)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_305",
    "data-name": "Caminho 305",
    d: "M143.977,668.438a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,143.977,668.438Z",
    transform: "translate(258.428 1204.982)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_306",
    "data-name": "Caminho 306",
    d: "M123.1,668.438a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,123.1,668.438Z",
    transform: "translate(220.14 1204.982)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_307",
    "data-name": "Caminho 307",
    d: "M102.215,668.438a8.476,8.476,0,1,0,8.477-8.429A8.452,8.452,0,0,0,102.215,668.438Z",
    transform: "translate(181.824 1204.982)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_308",
    "data-name": "Caminho 308",
    d: "M81.342,668.438a8.476,8.476,0,1,0,8.476-8.429A8.452,8.452,0,0,0,81.342,668.438Z",
    transform: "translate(143.537 1204.982)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_309",
    "data-name": "Caminho 309",
    d: "M60.453,668.438a8.476,8.476,0,1,0,8.476-8.429A8.452,8.452,0,0,0,60.453,668.438Z",
    transform: "translate(105.22 1204.982)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_310",
    "data-name": "Caminho 310",
    d: "M39.58,668.438a8.476,8.476,0,1,0,8.476-8.429A8.452,8.452,0,0,0,39.58,668.438Z",
    transform: "translate(66.932 1204.982)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_311",
    "data-name": "Caminho 311",
    d: "M164.866,647.667a8.476,8.476,0,1,0,8.477-8.429A8.454,8.454,0,0,0,164.866,647.667Z",
    transform: "translate(296.744 1166.882)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_312",
    "data-name": "Caminho 312",
    d: "M143.977,647.667a8.476,8.476,0,1,0,8.477-8.429A8.454,8.454,0,0,0,143.977,647.667Z",
    transform: "translate(258.428 1166.882)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_313",
    "data-name": "Caminho 313",
    d: "M123.1,647.667a8.476,8.476,0,1,0,8.477-8.429A8.454,8.454,0,0,0,123.1,647.667Z",
    transform: "translate(220.14 1166.882)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_314",
    "data-name": "Caminho 314",
    d: "M102.215,647.667a8.476,8.476,0,1,0,8.477-8.429A8.454,8.454,0,0,0,102.215,647.667Z",
    transform: "translate(181.824 1166.882)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_315",
    "data-name": "Caminho 315",
    d: "M81.342,647.667a8.476,8.476,0,1,0,8.476-8.429A8.453,8.453,0,0,0,81.342,647.667Z",
    transform: "translate(143.537 1166.882)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_316",
    "data-name": "Caminho 316",
    d: "M60.453,647.667a8.476,8.476,0,1,0,8.476-8.429A8.454,8.454,0,0,0,60.453,647.667Z",
    transform: "translate(105.22 1166.882)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_317",
    "data-name": "Caminho 317",
    d: "M39.58,647.667a8.476,8.476,0,1,0,8.476-8.429A8.454,8.454,0,0,0,39.58,647.667Z",
    transform: "translate(66.932 1166.882)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_318",
    "data-name": "Caminho 318",
    d: "M164.866,626.911a8.476,8.476,0,1,0,8.477-8.429A8.454,8.454,0,0,0,164.866,626.911Z",
    transform: "translate(296.744 1128.809)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_319",
    "data-name": "Caminho 319",
    d: "M143.977,626.911a8.476,8.476,0,1,0,8.477-8.429A8.454,8.454,0,0,0,143.977,626.911Z",
    transform: "translate(258.428 1128.809)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_320",
    "data-name": "Caminho 320",
    d: "M123.1,626.911a8.476,8.476,0,1,0,8.475-8.429A8.454,8.454,0,0,0,123.1,626.911Z",
    transform: "translate(220.14 1128.809)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_321",
    "data-name": "Caminho 321",
    d: "M102.215,626.911a8.476,8.476,0,1,0,8.477-8.429A8.454,8.454,0,0,0,102.215,626.911Z",
    transform: "translate(181.824 1128.809)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_322",
    "data-name": "Caminho 322",
    d: "M81.342,626.911a8.476,8.476,0,1,0,8.476-8.429A8.453,8.453,0,0,0,81.342,626.911Z",
    transform: "translate(143.537 1128.809)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_323",
    "data-name": "Caminho 323",
    d: "M60.453,626.911a8.476,8.476,0,1,0,8.476-8.429A8.454,8.454,0,0,0,60.453,626.911Z",
    transform: "translate(105.22 1128.809)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_324",
    "data-name": "Caminho 324",
    d: "M39.58,626.911a8.476,8.476,0,1,0,8.476-8.429A8.454,8.454,0,0,0,39.58,626.911Z",
    transform: "translate(66.932 1128.809)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_325",
    "data-name": "Caminho 325",
    d: "M164.864,606.141a8.476,8.476,0,1,0,8.477-8.429A8.454,8.454,0,0,0,164.864,606.141Z",
    transform: "translate(296.74 1090.711)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_326",
    "data-name": "Caminho 326",
    d: "M143.977,606.138a8.476,8.476,0,1,0,8.477-8.426A8.452,8.452,0,0,0,143.977,606.138Z",
    transform: "translate(258.428 1090.711)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_327",
    "data-name": "Caminho 327",
    d: "M123.1,606.138a8.476,8.476,0,1,0,8.475-8.426A8.452,8.452,0,0,0,123.1,606.138Z",
    transform: "translate(220.14 1090.711)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_328",
    "data-name": "Caminho 328",
    d: "M102.215,606.138a8.476,8.476,0,1,0,8.477-8.426A8.452,8.452,0,0,0,102.215,606.138Z",
    transform: "translate(181.824 1090.711)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_329",
    "data-name": "Caminho 329",
    d: "M81.342,606.138a8.476,8.476,0,1,0,8.476-8.426A8.452,8.452,0,0,0,81.342,606.138Z",
    transform: "translate(143.537 1090.711)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_330",
    "data-name": "Caminho 330",
    d: "M60.453,606.138a8.476,8.476,0,1,0,8.476-8.426A8.452,8.452,0,0,0,60.453,606.138Z",
    transform: "translate(105.22 1090.711)",
    fill: "#6c7a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_331",
    "data-name": "Caminho 331",
    d: "M39.58,606.138a8.476,8.476,0,1,0,8.476-8.426A8.452,8.452,0,0,0,39.58,606.138Z",
    transform: "translate(66.932 1090.711)",
    fill: "#6c7a89"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/auth-background.2cc5fdea9b9f2bd023a5df25d0098257.svg";
export { ForwardRef as ReactComponent };